// Hindi translations for the business management application
export default {
  // Landing page translations
  landing: {
    hero: {
      badge: 'भारतीय व्यवसायों के लिए',
      title: 'अपना व्यवसाय चलाएं।',
      subtitle: 'कागजी कार्रवाई नहीं।',
      description: 'भारतीय एसएमई के लिए आगामी एंटरप्राइज ओएस। जीएसटी, इन्वेंट्री और ट्रेड फाइनेंस को सुव्यवस्थित करें।',
      cta_waitlist: 'वेटलिस्ट में शामिल हों',
      cta_demo: 'आर्किटेक्चर देखें',
      trust_early: 'जल्द आ रहा है',
      trust_card: 'क्रेडिट कार्ड की जरूरत नहीं',
      trust_gst: 'जीएसटी केंद्रित',
      stats_revenue: 'राजस्व',
      stats_inventory: 'इन्वेंटरी'
    },
    social_proof: {
      stats: {
        smes: { value: 'भारतीय एसएमई', label: 'के लिए निर्माण' },
        gst: { value: 'जीएसटी केंद्रित', label: 'अनुपालन' },
        cloud: { value: 'क्लाउड नेटिव', label: 'आर्किटेक्चर' },
        status: { value: 'प्रारंभिक पहुंच', label: 'स्थिति' }
      }
    },
    problem: {
      badge: 'महत्वपूर्ण चुनौतियां',
      title: 'वह घर्षण जो आपके',
      subtitle: 'पैमाने को रोक रहा है।',
      description: "आधुनिक भारतीय व्यापार परिदृश्य तेजी से विकसित हो रहा है। पुराने उपकरण डिजिटल वाणिज्य और जीएसटी जटिलता की गति के लिए नहीं बनाए गए थे।",
      cards: {
        paperwork: {
          title: 'कागजी कार्रवाई में खोए घंटे',
          description: 'मैनुअल चालान, डेटा प्रविष्टि और सुलह हर हफ्ते 15+ घंटे खा जाते हैं। समय जो आपको विकास पर खर्च करना चाहिए।'
        },
        gst: {
          title: 'जीएसटी अनुपालन सिरदर्द',
          description: 'सही कर दरों की गणना करना, समय पर रिटर्न दाखिल करना और दंड से बचना एक निरंतर तकनीकी और मानसिक नाली है।'
        },
        inventory: {
          title: 'इन्वेंटरी ब्लाइंड स्पॉट',
          description: "स्टॉकआउट और ओवरस्टॉकिंग इसलिए होती है क्योंकि आपके पास अपने पूरे वेयरहाउस नेटवर्क में रीयल-टाइम दृश्यता नहीं होती है।"
        }
      }
    },
    features: {
      title: 'एंटरप्राइज़ पावर।',
      subtitle: 'आपके लिए सरलीकृत।',
      description: 'सोमा औद्योगिक-ग्रेड लेखांकन को आधुनिक व्यवसाय स्वामी के लिए डिज़ाइन किए गए एक सहज इंटरफ़ेस के साथ जोड़ती है।',
      cards: {
        invoicing: {
          title: 'जीएसटी चालान',
          description: 'सेकंड में जीएसटी-अनुपालन चालान बनाने के लिए डिज़ाइन किया गया। सटीक स्थानीय अनुपालन के साथ कर दरों की ऑटो-गणना करें।'
        },
        inventory: {
          title: 'इन्वेंटरी सिंक',
          description: 'मल्टी-सिटी गोदामों में रीयल-टाइम स्टॉक स्तरों को ट्रैक करें। इन्वेंट्री स्वास्थ्य पर भविष्य कहनेवाला अलर्ट।'
        },
        intelligence: {
          title: 'व्यापार खुफिया',
          description: 'हमारे स्थानीय आर्किटेक्चर के साथ परिष्कृत पी एंड एल, नकदी प्रवाह और कर रिपोर्ट तैयार करें।'
        },
        mobile: {
          title: 'एकीकृत मोबाइल',
          description: 'अपने फोन से अपने पूरे उद्यम को प्रबंधित करें। एंटरप्राइज़ पावर, उपभोक्ता सादगी।'
        }
      },
      learn_more: 'और जानें'
    },
    cta: {
      badge: 'प्री-लॉन्च एक्सेस',
      title: 'भविष्य का',
      subtitle: 'भारतीय व्यापार।',
      description: "सोमा के एंटरप्राइज़ आर्किटेक्चर का अनुभव करने वाले पहले लोगों में से बनें। गति, पैमाने और स्थानीय अनुपालन के लिए निर्मित।",
      btn_waitlist: 'वेटलिस्ट में शामिल हों',
      btn_features: 'सुविधाएँ देखें',
      benefits: {
        early_access: 'प्रारंभिक पहुंच',
        priority: 'प्राथमिकता ऑनबोर्डिंग',
        updates: 'अपडेट शामिल'
      }
    },
    differentiation: {
      badge: 'ओम्निचैनल आर्किटेक्चर',
      title: 'कहीं से भी',
      subtitle: 'व्यापार करें।',
      description: 'इस तरह डिज़ाइन किया गया है कि आप ग्राहक से बात करते समय अपने फोन पर चालान शुरू कर सकें, और बाद में अपने लैपटॉप पर इसे पूरा कर सकें। डेटा सभी उपकरणों पर तुरंत सिंक हो जाएगा, यहां तक ​​कि कम कनेक्टिविटी वाले क्षेत्रों में भी।',
      items: {
        mobile: {
          title: 'मोबाइल फर्स्ट',
          desc: 'भारतीय बाजार में हाई-स्पीड व्यापार के लिए तैयार किया गया।'
        },
        desktop: {
          title: 'डेस्कटॉप स्केल',
          desc: 'विशाल इन्वेंट्री ऑपरेशन और बल्क ट्रेड क्लियरिंग।'
        },
        sync: {
          title: 'ऑफ़लाइन सिंक',
          desc: 'डेटा स्थानीय रूप से रहता है। कनेक्ट होते ही सिंक हो जाता है।'
        }
      },
      stats: {
        latency: { value: '< 1s', label: 'लक्ष्य विलंबता' },
        uptime: { value: '99.9%', label: 'लक्ष्य अपटाइम' },
        crypto: { value: 'AES-256', label: 'क्रिप्टो' }
      },
      sync_status: 'लाइव सिंक'
    },
    faq: {
      badge: 'ज्ञान आधार',
      title: 'विवरण',
      subtitle: 'स्पष्ट करना।',
      questions: {
        setup: {
          q: 'लॉन्च होने के बाद मैं सोमा को कितनी जल्दी सेट कर पाऊंगा?',
          a: 'सोमा को 2 मिनट से भी कम समय में पूरी तरह से सेट करने के लिए डिज़ाइन किया गया है। बस अपना व्यवसाय नाम और जीएसटी नंबर जोड़ें, और आप तुरंत चालान बनाना शुरू कर सकते हैं। हम टैली, ज़ोहो या स्प्रेडशीट से मुफ्त माइग्रेशन सहायता प्रदान करने की भी योजना बना रहे हैं।'
        },
        security: {
          q: 'क्या मेरा व्यवसाय डेटा सुरक्षित है?',
          a: 'बिल्कुल। हम सभी डेटा के लिए बैंक-ग्रेड 256-बिट एन्क्रिप्शन लागू कर रहे हैं। आपकी जानकारी भारत में सुरक्षित सर्वरों पर कई बैकअप के साथ संग्रहीत की जाएगी। हम ISO 27001 प्रमाणित और पूरी तरह से DPDP अनुपालन के लिए निर्माण कर रहे हैं।'
        },
        knowledge: {
          q: 'क्या मुझे किसी लेखा या तकनीकी ज्ञान की आवश्यकता है?',
          a: 'बिल्कुल नहीं। सोमा को व्यवसाय मालिकों के लिए डिज़ाइन किया गया है, लेखाकारों के लिए नहीं। यदि आप व्हाट्सएप का उपयोग कर सकते हैं, तो आप सोमा का उपयोग करने में सक्षम होंगे। हम सभी जटिल जीएसटी गणना, कर वर्गीकरण और अनुपालन आवश्यकताओं को स्वचालित रूप से संभालते हैं।'
        },
        offline: {
          q: 'अगर मेरे पास इंटरनेट कनेक्शन नहीं है तो क्या होगा?',
          a: 'सोमा को ऑफ़लाइन भी काम करने के लिए डिज़ाइन किया गया है। आप हमारे मोबाइल ऐप पर चालान बनाना, इन्वेंट्री अपडेट करना और बिक्री रिकॉर्ड करना जारी रख सकते हैं। जैसे ही आप ऑनलाइन वापस आते हैं, सब कुछ आपके सभी उपकरणों पर स्वचालित रूप से सिंक हो जाता है।'
        },
        migration: {
          q: 'क्या मैं टैली से अपना मौजूदा डेटा माइग्रेट कर सकता हूं?',
          a: 'हाँ! हम टैली, ज़ोहो बुक्स या एक्सेल स्प्रेडशीट से आपके ग्राहक डेटा, उत्पाद कैटलॉग और ऐतिहासिक लेनदेन को मूल रूप से संभालने के लिए आयात उपकरण बना रहे हैं।'
        }
      },
      cta: {
        title: 'आर्किटेक्चरल सपोर्ट',
        link: 'हमारे इंजीनियरों से संपर्क करें'
      }
    },
    testimonials: {
      badge: 'हमारा ध्यान',
      title: 'हर भारतीय व्यवसाय',
      subtitle: 'के लिए डिजाइनिंग।',
      description: 'थोक विक्रेताओं से लेकर निर्माताओं तक, सोमा को आपकी अनूठी व्यापार आवश्यकताओं के अनुकूल होने के लिए डिज़ाइन किया जा रहा है।',
      featured: {
        title: 'थोक और वितरण',
        description: 'बल्क इन्वेंट्री, जटिल मूल्य निर्धारण स्तरों और क्रेडिट चक्रों को आसानी से प्रबंधित करें। सोमा को वॉल्यूम संभालने के लिए बनाया गया है ताकि आप व्यापार पर ध्यान केंद्रित कर सकें।',
        badge: {
          title: 'थोक',
          desc: 'उच्च मात्रा • कम मार्जिन'
        },
        stats: {
          inventory: { label: 'इन्वेंटरी', value: 'बैच ट्रैकिंग' },
          pricing: { label: 'मूल्य निर्धारण', value: 'मल्टी-टियर' },
          finance: { label: 'वित्त', value: 'क्रेडिट प्रबंधन' }
        }
      },
      industries: {
        manufacturing: {
          title: 'विनिर्माण',
          description: 'कच्चे माल, बिल ऑफ मैटेरियल्स (BOM) और उत्पादन लागत की सटीक ट्रैकिंग को लक्षित करना।'
        },
        retail: {
          title: 'खुदरा श्रृंखलाएं',
          description: 'नियोजित एकीकृत पॉइंट ऑफ़ सेल (POS), बारकोड स्कैनिंग और रीयल-टाइम मल्टी-स्टोर सिंक्रोनाइज़ेशन।'
        },
        service: {
          title: 'सेवा प्रदाता',
          description: 'परियोजना-आधारित बिलिंग, समय ट्रैकिंग और स्वचालित व्यय प्रबंधन के लिए डिज़ाइन किया गया।'
        }
      }
    },
  },
  features_page: {
      badge: 'SME OS कोर फीचर्स',
      title: 'इसके लिए निर्मित',
      subtitle: 'अजेय SME.',
      description: 'आधुनिक SMEs की जटिलताओं को हल करने के लिए सोमा को जमीन से ऊपर बनाया जा रहा है। जीएसटी को स्वचालित करें, इन्वेंट्री ट्रैक करें और एक ही प्लेटफॉर्म में रीयल-टाइम अंतर्दृष्टि प्राप्त करें।',
      cta_waitlist: 'वेटलिस्ट में शामिल हों',
      cta_learn_more: 'और जानें',
      engineered_workflows: 'इंजीनियर वर्कफ़्लो',
      testimonial: {
        quote: '"अंत में, एक बिजनेस ओएस जो भारतीय व्यापार की जटिलता को समझता है। हम अपने कार्यों को सोमा में स्थानांतरित करने के लिए उत्सुकता से प्रतीक्षा कर रहे हैं।"',
        author: 'अंकित वार्ष्णेय',
        role: 'सीईओ, वार्ष्णेय टेक्सटाइल्स (बीटा पार्टनर)'
      },
      final_cta: {
        title: 'भविष्य का अनुभव करने के लिए तैयार हैं?',
        description: 'भारतीय SME कार्यों को फिर से परिभाषित करने वाले प्लेटफॉर्म तक पहुंचने वाले पहले लोगों में से बनें। आज ही प्रारंभिक पहुंच का अनुरोध करें।',
        request_access: 'एक्सेस का अनुरोध करें',
        view_plans: 'प्लान देखें',
        footer: 'लोकल-फर्स्ट • जीएसटी अनुपालन • एंटरप्राइज़ स्केल'
      },
      features: {
        gst: {
          title: 'जीएसटी अनुपालन',
          description: 'भारतीय कर पारिस्थितिकी तंत्र के लिए तैयार स्वचालित जीएसटी फाइलिंग, चालान निर्माण और अनुपालन ट्रैकिंग।',
          benefits: {
            filing: 'स्वचालित GSTR फाइलिंग',
            alerts: 'रीयल-टाइम अनुपालन अलर्ट',
            validation: 'चालान सत्यापन'
          }
        },
        inventory: {
          title: 'इन्वेंटरी सिंक',
          description: 'स्मार्ट रीऑर्डर पॉइंट और एनालिटिक्स के साथ कई स्थानों पर रीयल-टाइम इन्वेंट्री ट्रैकिंग।',
          benefits: {
            tracking: 'मल्टी-लोकेशन ट्रैकिंग',
            alerts: 'स्वचालित रीऑर्डर अलर्ट',
            analytics: 'स्टॉक मूवमेंट एनालिटिक्स'
          }
        },
        analytics: {
          title: 'स्मार्ट एनालिटिक्स',
          description: 'स्वचालित P&L और नकदी प्रवाह रिपोर्ट के साथ अपने व्यवसाय के प्रदर्शन में गहरी अंतर्दृष्टि प्राप्त करें।',
          benefits: {
            pl: 'P&L विवरण',
            cashflow: 'नकदी प्रवाह विश्लेषण',
            tax: 'कर अनुकूलन अंतर्दृष्टि'
          }
        },
        crm: {
          title: 'ग्राहक CRM',
          description: 'इतिहास ट्रैकिंग और स्मार्ट जुड़ाव के माध्यम से अपने ग्राहकों के साथ स्थायी संबंध बनाएं।',
          benefits: {
            profiles: 'ग्राहक प्रोफाइल',
            history: 'ऑर्डर इतिहास',
            logs: 'संचार लॉग'
          }
        },
        global: {
          title: 'वैश्विक वाणिज्य',
          description: 'मल्टी-करेंसी समर्थन और FEMA-अनुपालन चालान वर्कफ़्लो के साथ विश्व स्तर पर विस्तार करें।',
          benefits: {
            rates: 'रीयल-टाइम विनिमय दरें',
            invoicing: 'मल्टी-करेंसी चालान',
            compliance: 'FEMA अनुपालन'
          }
        },
        security: {
          title: 'बैंक-ग्रेड सुरक्षा',
          description: 'आपका व्यवसाय डेटा उच्चतम एन्क्रिप्शन मानकों और स्थानीय अनुपालन द्वारा सुरक्षित है।',
          benefits: {
            encryption: 'एंड-टू-एंड एन्क्रिप्शन',
            backups: 'नियमित बैकअप',
            compliance: 'भारतीय DPDP अनुपालन'
          }
        }
      }
    },
    pricing_page: {
      badge: 'पारदर्शी मूल्य निर्धारण',
      title: 'सरल स्केल।',
      subtitle: 'कोई जटिलता नहीं।',
      description: 'अपने व्यवसाय को बढ़ाने के लिए सही योजना चुनें। पारदर्शिता, समानता और स्थानीय-प्रथम वास्तुकला के लिए समर्पित।',
      billing: {
        monthly: 'मासिक',
        yearly: 'वार्षिक',
        save: '20% बचाएं'
      },
      per_month: '/माह',
      yearly_discount: 'वार्षिक छूट',
      plans: {
        features_title: 'शामिल सुविधाएँ',
        per_month: '/माह',
        recommended: 'स्केल के लिए अनुशंसित',
        starter: {
          name: 'स्टार्टर',
          description: 'छोटे व्यवसायों और बढ़ते स्टार्टअप के लिए बिल्कुल सही',
          cta: 'वेटलिस्ट में शामिल हों',
          features: {
            invoices: '100 चालान/माह तक',
            gst: 'बुनियादी जीएसटी अनुपालन',
            inventory: 'एकल स्थान इन्वेंट्री',
            support: 'ईमेल समर्थन',
            reporting: 'बुनियादी रिपोर्टिंग',
            mobile: 'मोबाइल ऐप एक्सेस'
          }
        },
        professional: {
          name: 'प्रोफेशनल',
          description: 'जटिल जरूरतों वाले बढ़ते व्यवसायों के लिए आदर्श',
          cta: 'वेटलिस्ट में शामिल हों',
          features: {
            invoices: 'असीमित चालान',
            gst: 'उन्नत जीएसटी अनुपालन',
            inventory: 'मल्टी-लोकेशन इन्वेंट्री',
            support: 'प्राथमिकता समर्थन',
            analytics: 'उन्नत एनालिटिक्स',
            api: 'एपीआई एक्सेस',
            integrations: 'कस्टम एकीकरण',
            users: 'मल्टी-यूज़र एक्सेस'
          }
        },
        enterprise: {
          name: 'एंटरप्राइज़',
          description: 'टीम वर्कफ़्लो वाले बड़े पैमाने के व्यवसायों के लिए',
          cta: 'प्रारंभिक पहुंच के लिए संपर्क करें',
          features: {
            all_pro: 'प्रोफेशनल में सब कुछ',
            manager: 'समर्पित खाता प्रबंधक',
            workflows: 'कस्टम वर्कफ़्लो',
            security: 'उन्नत सुरक्षा सुविधाएँ',
            whitelabel: 'व्हाइट-लेबल विकल्प',
            access: 'भूमिका-आधारित पहुंच',
            reporting: 'कस्टम रिपोर्टिंग',
            deployment: 'ऑन-प्रेमिस परिनियोजन'
          }
        }
      },
      faq: {
        badge: 'FAQ',
        title: 'प्रश्न',
        subtitle: 'बिलिंग और मूल्य निर्धारण के बारे में आपको जो कुछ भी जानने की आवश्यकता है।',
        questions: {
          trial: {
            q: 'क्या कोई मुफ्त परीक्षण होगा?',
            a: 'हाँ! लॉन्च होने पर, सभी प्लान 14-दिन के मुफ्त परीक्षण के साथ आएंगे। आपको सभी सुविधाओं तक पूरी पहुंच मिलेगी ताकि आप देख सकें कि सोमा आपके व्यवसाय में क्या मूल्य लाता है। क्रेडिट कार्ड की आवश्यकता नहीं होगी।'
          },
          change: {
            q: 'क्या मैं कभी भी प्लान बदल सकता हूँ?',
            a: 'बिल्कुल। आप किसी भी समय अपने प्लान को अपग्रेड या डाउनग्रेड कर सकेंगे। जब आप अपग्रेड करते हैं, तो नई सुविधाएँ तुरंत उपलब्ध हो जाएंगी।'
          },
          payment: {
            q: 'कौन से भुगतान तरीके स्वीकार किए जाएंगे?',
            a: 'हम भारत में लोकप्रिय सभी प्रमुख क्रेडिट कार्ड, डेबिट कार्ड, यूपीआई, नेट बैंकिंग और डिजिटल वॉलेट स्वीकार करने की योजना बना रहे हैं, जिसमें PhonePe, Paytm और Google Pay शामिल हैं।'
          },
          security: {
            q: 'क्या मेरा डेटा सुरक्षित है?',
            a: 'हाँ, हम एंटरप्राइज़-ग्रेड 256-बिट SSL एन्क्रिप्शन का उपयोग करते हैं। हम SOC2 अनुपालन और यह सुनिश्चित करने के लिए सभी भारतीय डेटा संरक्षण नियमों (DPDP) का पालन कर रहे हैं कि आपका व्यवसाय डेटा सुरक्षित है।'
          }
        }
      },
      final_cta: {
        title: 'तैयार हैं',
        subtitle: 'गंभीर पैमाने के लिए?',
        book_call: 'आर्किटेक्चर कॉल बुक करें',
        contact_sales: 'बिक्री से संपर्क करें',
        footer: 'सोमा को तैनात करें। विरासत बनाएं।'
      },
    },
    solutions_page: {
        badge: 'उद्योग विशिष्ट डीएनए',
        title: 'कस्टम मेड',
        subtitle: 'आपके पैमाने के लिए।',
        description: 'जेनेरिक सॉफ़्टवेयर विफल हो जाता है क्योंकि आपका व्यवसाय अद्वितीय है। सोमा आपके उद्योग विशिष्ट वर्कफ़्लो के लिए बॉक्स से बाहर अनुकूलित होता है।',
        cta_contact: 'बिक्री से संपर्क करें',
        cta_case_studies: 'केस स्टडीज देखें',
        core_workflow: 'कोर वर्कफ़्लो घटक',
        top_users: 'शीर्ष उद्योग उपयोगकर्ता',
        validated_results: 'सत्यापित परिणाम',
        deployment: 'एंटरप्राइज़ परिनियोजन',
        built_for_scale: 'जटिल भारतीय पैमाने के लिए बनाया गया।',
        industries: {
          retail: {
            title: 'Retail & E-commerce',
            description: 'एकीकृत इन्वेंट्री और मल्टी-चैनल बिलिंग के साथ अपने खुदरा व्यवसाय को स्केल करें।',
            features: {
              inventory: 'मल्टी-चैनल इन्वेंट्री सिंक',
              pos: 'पॉइंट ऑफ सेल (POS) एकीकरण',
              loyalty: 'लॉयल्टी और उपहार कार्ड',
              reordering: 'स्वचालित स्टॉक रीऑर्डरिंग'
            },
            tags: {
              fashion: 'फैशन',
              electronics: 'इलेक्ट्रॉनिक्स',
              chains: 'रिटेल चेन'
            },
            proof: {
              label: 'स्टॉकआउट कमी',
              company: 'फैशन रिटेल'
            }
          },
          manufacturing: {
            title: 'Manufacturing',
            description: 'स्मार्ट लागत ट्रैकिंग और कच्चे माल के वर्कफ़्लो के साथ उत्पादन को अनुकूलित करें।',
            features: {
              planning: 'उत्पादन योजना (MRP)',
              bom: 'BOM प्रबंधन',
              waste: 'अपशिष्ट और स्क्रैपेज ट्रैकिंग',
              labor: 'श्रम लागत एट्रिब्यूशन'
            },
            tags: {
              auto: 'ऑटो पार्ट्स',
              textile: 'टेक्सटाइल मिल्स',
              food: 'फूड टेक'
            },
            proof: {
              label: 'अपशिष्ट कमी',
              company: 'विनिर्माण'
            }
          },
          services: {
            title: 'Services & Agencies',
            description: 'शून्य प्रयास के साथ क्लाइंट बिलिंग और प्रोजेक्ट लाभप्रदता को सुव्यवस्थित करें।',
            features: {
              accounting: 'प्रोजेक्ट-आधारित लेखांकन',
              portal: 'भुगतान के लिए क्लाइंट पोर्टल',
              tracking: 'चालान के लिए समय ट्रैकिंग',
              billing: 'आवर्ती सेवा बिलिंग'
            },
            tags: {
              it: 'IT एजेंसियां',
              law: 'कानूनी फर्म',
              consulting: 'कंसल्टिंग'
            },
            proof: {
              label: 'तेज़ बिलिंग',
              company: 'सेवा एजेंसी'
            }
          },
          healthcare: {
            title: 'Healthcare',
            description: 'चिकित्सा पद्धतियों और प्रयोगशालाओं के लिए अनुपालन-तैयार बैक-ऑफिस उपकरण।',
            features: {
              inventory: 'चिकित्सा इन्वेंट्री नियंत्रण',
              claims: 'बीमा दावा ट्रैकिंग',
              billing: 'रोगी बिलिंग स्वचालन',
              reporting: 'विनियामक रिपोर्टिंग'
            },
            tags: {
              clinics: 'क्लिनिक',
              pharmacies: 'फार्मेसी',
              labs: 'लैब'
            },
            proof: {
              label: 'बिलिंग सटीकता',
              company: 'हेल्थकेयर'
            }
          }
        },
        cta_section: {
        title_prefix: 'अपना समाधान DNA',
        title_suffix: 'खोजने के लिए तैयार हैं?',
        book_audit: 'आर्किटेक्चर ऑडिट बुक करें',
        talk_expert: 'विशेषज्ञ से बात करें',
        footer_text: 'स्थानीय रूप से तैनात करें। विश्व स्तर पर स्केल करें।'
      }
    },
    resources_page: {
    badge: 'सोमा नॉलेज हब',
    title_prefix: 'सीखें',
    title_suffix: 'समृद्ध होना',
    description: 'अनन्य गाइड, उद्योग अंतर्दृष्टि और तकनीकी दस्तावेज जो आपको एक अजेय भारतीय SME बनाने में मदद करेंगे।',
    ledger: {
      title: 'द लेजर',
      subtitle: 'SME स्केल और लोकल-फर्स्ट आर्किटेक्चर पर एक पत्रिका।',
      cta: 'संग्रह का अन्वेषण करें'
    },
    implementation: {
      title_prefix: 'कार्यान्वयन',
      title_suffix: 'महारत',
      description: 'हमारे आर्किटेक्ट बड़े पैमाने पर एंटरप्राइज़ डिप्लॉयमेंट और कस्टम निर्माण वर्कफ़्लो के लिए समर्पित सत्र प्रदान करते हैं।',
      cta_training: 'प्रशिक्षण शेड्यूल करें',
      cta_support: 'तकनीकी सहायता',
      footer: 'आर्किटेक्चर • इंटीग्रेशन • स्केल'
    },
    cards: {
      quick_start: {
        title: "त्वरित प्रारंभ गाइड",
        description: "10 मिनट के भीतर सोमा के साथ अपनी यात्रा शुरू करने के लिए आपको जो कुछ भी चाहिए।",
        tag: "आवश्यक"
      },
      mastering_gst: {
        title: "GST में महारत",
        description: "GSTR ऑटोमेशन, ई-वे बिल और स्थानीय कर अनुपालन में गहरा गोता।",
        tag: "अद्यतन 2026"
      },
      inventory_strategy: {
        title: "इन्वेंटरी रणनीति",
        description: "V.K. प्रिंट्स ने सोमा के मल्टी-लोकेशन सिंक का उपयोग करके 400% वृद्धि का प्रबंधन कैसे किया।",
        tag: "केस स्टडी"
      },
      api_docs: {
        title: "API दस्तावेज़ीकरण",
        description: "कस्टम इंटीग्रेशन बनाएं और सोमा की क्षमताओं का विस्तार करें।",
        tag: "तकनीकी"
      },
      community: {
        title: "सामुदायिक मंच",
        description: "अन्य व्यवसाय मालिकों और सोमा विशेषज्ञों के साथ जुड़ें।",
        tag: "बाहरी"
      },
      webinar: {
        title: "वेबिनार: GST 2026",
        description: "नए कर नियमों पर हमारे नवीनतम सत्र की रिकॉर्डिंग देखें।",
        tag: "नया"
      }
    }
  },
  // Layout translations
  layout: {
    navbar: {
      login: 'लॉगिन',
      get_started: 'शुरू करें',
      dashboard: 'डैशबोर्ड',
      links: {
        features: 'विशेषताएं',
        pricing: 'मूल्य निर्धारण',
        solutions: 'समाधान',
        resources: 'संसाधन'
      }
    },
    footer: {
      brand_desc: 'भारतीय उद्यमों के पैमाने के लिए इंजीनियर प्रीमियम बिजनेस ऑपरेटिंग सिस्टम।',
      engineered_for: 'इंजीनियर',
      excellence: 'उत्कृष्टता',
      sections: {
        product: 'उत्पाद',
        company: 'कंपनी',
        resources: 'संसाधन',
        legal: 'कानूनी'
      },
      links: {
        features: 'विशेषताएं',
        pricing: 'मूल्य निर्धारण',
        solutions: 'समाधान',
        resources: 'संसाधन',
        about: 'के बारे में',
        blog: 'ब्लॉग',
        careers: 'करियर',
        contact: 'संपर्क',
        docs: 'दस्तावेज़ीकरण',
        help: 'सहायता केंद्र',
        api: 'एपीआई संदर्भ',
        status: 'स्थिति',
        privacy: 'गोपनीयता',
        terms: 'शर्तें',
        security: 'सुरक्षा'
      },
      copyright: 'सोमा टेक्नोलॉजीज। सर्वाधिकार सुरक्षित।'
    }
  },
  // Common UI elements
  common: {
    loading: 'लोड हो रहा है...',
    save: 'सेव करें',
    cancel: 'रद्द करें',
    delete: 'डिलीट करें',
    edit: 'संपादित करें',
    add: 'जोड़ें',
    create: 'बनाएं',
    update: 'अपडेट करें',
    search: 'खोजें',
    filter: 'फिल्टर',
    export: 'एक्सपोर्ट',
    import: 'इम्पोर्ट',
    print: 'प्रिंट',
    download: 'डाउनलोड',
    upload: 'अपलोड',
    submit: 'सबमिट करें',
    reset: 'रीसेट करें',
    clear: 'साफ करें',
    confirm: 'पुष्टि करें',
    yes: 'हां',
    no: 'नहीं',
    ok: 'ठीक है',
    close: 'बंद करें',
    back: 'वापस',
    next: 'अगला',
    previous: 'पिछला',
    finish: 'समाप्त',
    continue: 'जारी रखें',
    skip: 'छोड़ें',
    retry: 'पुनः प्रयास',
    refresh: 'रिफ्रेश',
    view: 'देखें',
    details: 'विवरण',
    settings: 'सेटिंग्स',
    help: 'सहायता',
    about: 'के बारे में',
    contact: 'संपर्क',
    support: 'सहायता',
    feedback: 'फीडबैक',
    logout: 'लॉगआउट',
    login: 'लॉगिन',
    register: 'रजिस्टर',
    profile: 'प्रोफाइल',
    account: 'खाता',
    dashboard: 'डैशबोर्ड',
    home: 'होम',
    menu: 'मेन्यू',
    navigation: 'नेवीगेशन',
    sidebar: 'साइडबार',
    header: 'हेडर',
    footer: 'फुटर',
    content: 'सामग्री',
    main: 'मुख्य',
    section: 'सेक्शन',
    page: 'पेज',
    tab: 'टैब',
    panel: 'पैनल',
    modal: 'मोडल',
    dialog: 'डायलॉग',
    form: 'फॉर्म',
    field: 'फील्ड',
    input: 'इनपुट',
    select: 'चुनें',
    option: 'विकल्प',
    checkbox: 'चेकबॉक्स',
    radio: 'रेडियो',
    button: 'बटन',
    link: 'लिंक',
    image: 'इमेज',
    icon: 'आइकन',
    text: 'टेक्स्ट',
    title: 'शीर्षक',
    description: 'विवरण',
    name: 'नाम',
    email: 'ईमेल',
    phone: 'फोन',
    address: 'पता',
    city: 'शहर',
    state: 'राज्य',
    country: 'देश',
    zipcode: 'पिन कोड',
    date: 'तारीख',
    time: 'समय',
    datetime: 'तारीख और समय',
    status: 'स्थिति',
    type: 'प्रकार',
    category: 'श्रेणी',
    priority: 'प्राथमिकता',
    quantity: 'मात्रा',
    price: 'कीमत',
    amount: 'राशि',
    total: 'कुल',
    subtotal: 'उप-योग',
    tax: 'कर',
    discount: 'छूट',
    currency: 'मुद्रा',
    unit: 'इकाई',
    notes: 'नोट्स',
    comments: 'टिप्पणियां',
    tags: 'टैग्स',
    actions: 'क्रियाएं',
    options: 'विकल्प',
    preferences: 'प्राथमिकताएं',
    configuration: 'कॉन्फ़िगरेशन',
    advanced: 'उन्नत',
    basic: 'बुनियादी',
    general: 'सामान्य',
    security: 'सुरक्षा',
    privacy: 'गोपनीयता',
    notifications: 'सूचनाएं',
    alerts: 'अलर्ट',
    warnings: 'चेतावनी',
    errors: 'त्रुटियां',
    success: 'सफलता',
    info: 'जानकारी',
    tips: 'सुझाव',
    guides: 'गाइड',
    tutorials: 'ट्यूटोरियल',
    documentation: 'दस्तावेज़',
    faq: 'अक्सर पूछे जाने वाले प्रश्न',
    terms: 'नियम',
    conditions: 'शर्तें',
    policy: 'नीति',
    agreement: 'समझौता',
    license: 'लाइसेंस',
    version: 'संस्करण',
    active: 'सक्रिय',
    inactive: 'निष्क्रिय',
    pending: 'लंबित',
    completed: 'पूर्ण',
    failed: 'असफल',
    cancelled: 'रद्द',
    approved: 'अनुमोदित',
    rejected: 'अस्वीकृत',
    draft: 'मसौदा',
    published: 'प्रकाशित',
    archived: 'संग्रहीत',
    deleted: 'डिलीट',
    new: 'नया',
    old: 'पुराना',
    recent: 'हाल का',
    latest: 'नवीनतम',
    popular: 'लोकप्रिय',
    featured: 'फीचर्ड',
    recommended: 'अनुशंसित',
    trending: 'ट्रेंडिंग',
    high: 'उच्च',
    medium: 'मध्यम',
    low: 'कम',
    urgent: 'तत्काल',
    normal: 'सामान्य',
    critical: 'महत्वपूर्ण',
    important: 'जरूरी',
    optional: 'वैकल्पिक',
    required: 'आवश्यक',
    mandatory: 'अनिवार्य',
    public: 'सार्वजनिक',
    private: 'निजी',
    shared: 'साझा',
    personal: 'व्यक्तिगत',
    business: 'व्यापार',
    professional: 'पेशेवर',
    enterprise: 'उद्यम',
    premium: 'प्रीमियम',
    free: 'मुफ्त',
    paid: 'भुगतान',
    trial: 'ट्रायल',
    demo: 'डेमो',
    beta: 'बीटा',
    alpha: 'अल्फा',
    stable: 'स्थिर',
    development: 'विकास',
    production: 'उत्पादन',
    testing: 'परीक्षण',
    staging: 'स्टेजिंग',
    maintenance: 'रखरखाव',
    backup: 'बैकअप',
    restore: 'पुनर्स्थापना',
    sync: 'सिंक',
    migrate: 'माइग्रेट',
    transfer: 'स्थानांतरण',
    copy: 'कॉपी',
    move: 'मूव',
    duplicate: 'डुप्लिकेट',
    clone: 'क्लोन',
    merge: 'मर्ज',
    split: 'स्प्लिट',
    combine: 'संयोजन',
    separate: 'अलग',
    group: 'ग्रुप',
    ungroup: 'अनग्रुप',
    sort: 'सॉर्ट',
    order: 'ऑर्डर',
    arrange: 'व्यवस्थित',
    organize: 'संगठित',
    manage: 'प्रबंधन',
    control: 'नियंत्रण',
    monitor: 'मॉनिटर',
    track: 'ट्रैक',
    analyze: 'विश्लेषण',
    report: 'रिपोर्ट',
    statistics: 'आंकड़े',
    metrics: 'मेट्रिक्स',
    analytics: 'एनालिटिक्स',
    insights: 'अंतर्दृष्टि',
    trends: 'रुझान',
    patterns: 'पैटर्न',
    data: 'डेटा',
    information: 'जानकारी',
    content: 'सामग्री',
    media: 'मीडिया',
    files: 'फाइलें',
    documents: 'दस्तावेज़',
    images: 'इमेज',
    videos: 'वीडियो',
    audio: 'ऑडियो',
    attachments: 'अटैचमेंट',
    downloads: 'डाउनलोड',
    uploads: 'अपलोड',
    storage: 'स्टोरेज',
    memory: 'मेमोरी',
    cache: 'कैश',
    database: 'डेटाबेस',
    server: 'सर्वर',
    client: 'क्लाइंट',
    network: 'नेटवर्क',
    internet: 'इंटरनेट',
    connection: 'कनेक्शन',
    bandwidth: 'बैंडविड्थ',
    speed: 'गति',
    performance: 'प्रदर्शन',
    optimization: 'अनुकूलन',
    efficiency: 'दक्षता',
    quality: 'गुणवत्ता',
    reliability: 'विश्वसनीयता',
    stability: 'स्थिरता',
    safety: 'सुरक्षा',
    protection: 'सुरक्षा',
    encryption: 'एन्क्रिप्शन',
    authentication: 'प्रमाणीकरण',
    authorization: 'प्राधिकरण',
    permission: 'अनुमति',
    access: 'पहुंच',
    rights: 'अधिकार',
    privileges: 'विशेषाधिकार',
    roles: 'भूमिकाएं',
    users: 'उपयोगकर्ता',
    groups: 'समूह',
    teams: 'टीमें',
    organizations: 'संगठन',
    companies: 'कंपनियां',
    departments: 'विभाग',
    divisions: 'डिवीजन',
    branches: 'शाखाएं',
    locations: 'स्थान',
    regions: 'क्षेत्र',
    countries: 'देश',
    languages: 'भाषाएं',
    currencies: 'मुद्राएं',
    timezones: 'समय क्षेत्र',
    formats: 'प्रारूप',
    templates: 'टेम्प्लेट',
    themes: 'थीम',
    styles: 'स्टाइल',
    layouts: 'लेआउट',
    designs: 'डिज़ाइन',
    colors: 'रंग',
    fonts: 'फॉन्ट',
    sizes: 'आकार',
    dimensions: 'आयाम',
    positions: 'स्थितियां',
    alignments: 'संरेखण',
    margins: 'मार्जिन',
    padding: 'पैडिंग',
    borders: 'बॉर्डर',
    shadows: 'छाया',
    effects: 'प्रभाव',
    animations: 'एनीमेशन',
    transitions: 'ट्रांज़िशन',
    interactions: 'इंटरैक्शन',
    gestures: 'जेस्चर',
    shortcuts: 'शॉर्टकट',
    hotkeys: 'हॉटकी',
    commands: 'कमांड',
    functions: 'फ़ंक्शन',
    features: 'फीचर',
    capabilities: 'क्षमताएं',
    tools: 'उपकरण',
    utilities: 'उपयोगिताएं',
    widgets: 'विजेट',
    components: 'कंपोनेंट',
    modules: 'मॉड्यूल',
    plugins: 'प्लगइन',
    extensions: 'एक्सटेंशन',
    addons: 'ऐड-ऑन',
    integrations: 'एकीकरण',
    connections: 'कनेक्शन',
    apis: 'एपीआई',
    services: 'सेवाएं',
    applications: 'एप्लिकेशन',
    software: 'सॉफ्टवेयर',
    hardware: 'हार्डवेयर',
    devices: 'डिवाइस',
    platforms: 'प्लेटफॉर्म',
    systems: 'सिस्टम',
    frameworks: 'फ्रेमवर्क',
    libraries: 'लाइब्रेरी',
    packages: 'पैकेज',
    dependencies: 'निर्भरताएं',
    requirements: 'आवश्यकताएं',
    specifications: 'विनिर्देश',
    standards: 'मानक',
    protocols: 'प्रोटोकॉल',
    schemas: 'स्कीमा',
    structures: 'संरचनाएं',
    models: 'मॉडल',
    entities: 'इकाइयां',
    objects: 'ऑब्जेक्ट',
    items: 'आइटम',
    elements: 'तत्व',
    parts: 'भाग',
    pieces: 'टुकड़े',
    fragments: 'खंड',
    sections: 'सेक्शन',
    chapters: 'अध्याय',
    pages: 'पेज',
    articles: 'लेख',
    posts: 'पोस्ट',
    entries: 'प्रविष्टियां',
    records: 'रिकॉर्ड',
    logs: 'लॉग',
    history: 'इतिहास',
    timeline: 'टाइमलाइन',
    schedule: 'शेड्यूल',
    calendar: 'कैलेंडर',
    events: 'इवेंट',
    appointments: 'अपॉइंटमेंट',
    meetings: 'मीटिंग',
    conferences: 'कॉन्फ्रेंस',
    calls: 'कॉल',
    messages: 'संदेश',
    emails: 'ईमेल',
    reminders: 'रिमाइंडर',
    tasks: 'कार्य',
    todos: 'टू-डू',
    projects: 'प्रोजेक्ट',
    workflows: 'वर्कफ़्लो',
    processes: 'प्रक्रियाएं',
    procedures: 'प्रक्रियाएं',
    steps: 'चरण',
    stages: 'चरण',
    phases: 'चरण',
    milestones: 'मील के पत्थर',
    deadlines: 'समय सीमा',
    goals: 'लक्ष्य',
    objectives: 'उद्देश्य',
    targets: 'लक्ष्य',
    achievements: 'उपलब्धियां',
    results: 'परिणाम',
    outcomes: 'परिणाम',
    outputs: 'आउटपुट',
    inputs: 'इनपुट',
    resources: 'संसाधन',
    assets: 'संपत्ति',
    materials: 'सामग्री',
    supplies: 'आपूर्ति',
    equipment: 'उपकरण',
    instruments: 'उपकरण',
    machines: 'मशीनें',
    vehicles: 'वाहन',
    facilities: 'सुविधाएं',
    buildings: 'इमारतें',
    rooms: 'कमरे',
    spaces: 'स्थान',
    areas: 'क्षेत्र',
    zones: 'क्षेत्र',
    done: 'हो गया',
    undone: 'अधूरा',
    accomplished: 'पूर्ण',
    unaccomplished: 'अपूर्ण'
  },

  // Navigation
  navigation: {
    home: 'होम',
    dashboard: 'डैशबोर्ड',
    inventory: 'इन्वेंटरी',
    orders: 'ऑर्डर',
    customers: 'ग्राहक',
    suppliers: 'आपूर्तिकर्ता',
    purchases: 'खरीदारी',
    analytics: 'एनालिटिक्स',
    reports: 'रिपोर्ट',
    settings: 'सेटिंग्स',
    profile: 'प्रोफाइल',
    logout: 'लॉगआउट',
    help: 'सहायता',
    support: 'सहायता'
  },

  // Authentication
  auth: {
    login: 'लॉगिन',
    register: 'रजिस्टर',
    logout: 'लॉगआउट',
    forgotPassword: 'पासवर्ड भूल गए',
    resetPassword: 'पासवर्ड रीसेट करें',
    changePassword: 'पासवर्ड बदलें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    confirmPassword: 'पासवर्ड की पुष्टि करें',
    rememberMe: 'मुझे याद रखें',
    loginButton: 'साइन इन',
    registerButton: 'साइन अप',
    alreadyHaveAccount: 'पहले से खाता है?',
    dontHaveAccount: 'खाता नहीं है?',
    signInHere: 'यहां साइन इन करें',
    signUpHere: 'यहां साइन अप करें',
    invalidCredentials: 'गलत ईमेल या पासवर्ड',
    accountCreated: 'खाता सफलतापूर्वक बनाया गया',
    passwordResetSent: 'पासवर्ड रीसेट लिंक आपके ईमेल पर भेजा गया',
    passwordChanged: 'पासवर्ड सफलतापूर्वक बदला गया',
    login_page: {
      title: 'एंटरप्राइज ऑपरेटिंग सिस्टम।',
      features: {
        speed: { title: 'स्थानीय गति', desc: 'भारतीय बाजार के लिए निर्मित उच्च प्रदर्शन वास्तुकला।' },
        trust: { title: 'एन्क्रिप्टेड ट्रस्ट', desc: 'आपके संवेदनशील वित्तीय डेटा के लिए बैंक-ग्रेड सुरक्षा प्रोटोकॉल।' }
      },
      serving: '10,000+ भारतीय उद्यमों की सेवा',
      welcome: 'वापसी पर स्वागत है।',
      subtitle: 'केवल अधिकृत पहुंच। कृपया अपनी साख सत्यापित करें।',
      email_label: 'ईमेल आर्किटेक्चर',
      password_label: 'सुरक्षा कुंजी',
      reset_access: 'एक्सेस रीसेट करें',
      submit: 'डैशबोर्ड प्रारंभ करें',
      verifying: 'साख सत्यापित कर रहा है...',
      third_party: 'तृतीय पक्ष प्रमाणीकरण',
      verify_google: 'Google के साथ सत्यापित करें',
      no_account: 'खाता नहीं है?',
      open_account: 'एंटरप्राइज खाता खोलें'
    },
    register_page: {
      title: 'कुलीन वर्ग में शामिल हों।',
      features: {
        gst: { title: 'जीएसटी अनुकूलित', desc: 'एंटरप्राइज-ग्रेड अनुपालन इंजन।' },
        sync: { title: 'परमाणु सिंक', desc: 'उपकरणों पर तत्काल डेटा प्रसार।' }
      },
      testimonial: '"2 से 20 स्थानों तक स्केल करने के लिए हमें जिस बुनियादी ढांचे की आवश्यकता थी वह सोमा है। (Soma is the infrastructure we needed to scale from 2 to 20 locations.)"',
      testimonial_author: 'राजेश कुमार',
      testimonial_role: 'मालिक, ग्लोबल ट्रेडर्स',
      form_title: 'खाता खोलें।',
      form_subtitle: 'कुलीन 14-दिवसीय परीक्षण के साथ अपने व्यवसाय की वास्तुकला को सुरक्षित करें।',
      labels: {
        first_name: 'प्रथम नाम',
        last_name: 'अंतिम नाम',
        email: 'कॉर्पोरेट ईमेल',
        password: 'सुरक्षा कुंजी',
        confirm_password: 'कुंजी की पुष्टि करें',
        business_name: 'व्यवसाय पहचान',
        phone: 'फोन नंबर',
        entity_type: 'इकाई प्रकार',
        sector: 'क्षेत्र'
      },
      placeholders: {
        select_type: 'प्रकार चुनें',
        select_industry: 'उद्योग चुनें'
      },
      submit: 'एक्सेस का अनुरोध करें',
      already_registered: 'पहले से पंजीकृत?',
      sign_in: 'अधिकृत साइन इन'
    }
  },

  // Business Management
  // business: {
  //   name: 'व्यापार का नाम',
  //   type: 'व्यापार का प्रकार',
  //   category: 'श्रेणी',
  //   description: 'विवरण',
  //   address: 'पता',
  //   phone: 'फोन नंबर',
  //   email: 'ईमेल पता',
  //   website: 'वेबसाइट',
  //   gstNumber: 'जीएसटी नंबर',
  //   panNumber: 'पैन नंबर',
  //   bankAccount: 'बैंक खाता',
  //   ifscCode: 'आईएफएससी कोड',
  //   accountNumber: 'खाता संख्या',
  //   accountHolder: 'खाता धारक का नाम'
  // },

 business: {
  profile: "व्यवसाय प्रोफ़ाइल",
  edit_profile: "प्रोफ़ाइल संपादित करें",
  create_profile: "व्यवसाय प्रोफ़ाइल बनाएँ",
  edit_business_profile: "व्यवसाय प्रोफ़ाइल संपादित करें",
  create_business_profile: "व्यवसाय प्रोफ़ाइल बनाएँ",
  no_profile_found: "कोई व्यवसाय प्रोफ़ाइल नहीं मिली",
  no_business_profile: "कोई व्यवसाय प्रोफ़ाइल नहीं मिली",
  no_business_profile_description: "आपने अभी तक अपनी व्यवसाय प्रोफ़ाइल सेटअप नहीं की है। सभी सुविधाओं को अनलॉक करने के लिए एक प्रोफ़ाइल बनाएँ।",
  go_back: "वापस जाएँ",
  basic_info: "मूल जानकारी",
  business_name: "व्यवसाय का नाम",
  enter_name: "व्यवसाय का नाम दर्ज करें",
  business_type: "व्यवसाय का प्रकार",
  select_type: "व्यवसाय का प्रकार चुनें",
  email: "ईमेल",
  enter_email: "ईमेल पता दर्ज करें",
  phone: "फ़ोन",
  enter_phone: "फ़ोन नंबर दर्ज करें",
  address: "पता",
  enter_address: "पूरा पता दर्ज करें",
  category: "श्रेणी",
  select_category: "श्रेणी चुनें",
  annual_turnover: "वार्षिक कारोबार",
  select_turnover: "कारोबार की श्रेणी चुनें",
  turnover_range_0_5L: "₹0 - ₹5 लाख",
  turnover_range_5L_20L: "₹5 लाख - ₹20 लाख",
  turnover_range_20L_1Cr: "₹20 लाख - ₹1 करोड़",
  turnover_range_1Cr_plus: "₹1 करोड़ से अधिक",
  fetch_profile_error: "व्यवसाय प्रोफ़ाइल प्राप्त करने में विफल",
  fetch_gst_error: "GST सेटिंग्स प्राप्त करने में विफल",
  toggle_gst_error: "GST सुविधाएँ चालू/बंद करने में विफल",
  update_gst_status_error: "GST स्थिति अपडेट करने में विफल",
  save_error: "परिवर्तन सहेजने में विफल",
  gst_registered: "GST पंजीकृत",
  gst_number: "GST नंबर",
  registration_date: "पंजीकरण तिथि",
  flower_vendor: "फूल विक्रेता",
  grocery_store: "किराना स्टोर",
  textile_shop: "वस्त्र दुकान",
  hardware_store: "हार्डवेयर स्टोर",
  electronics_shop: "इलेक्ट्रॉनिक्स स्टोर",
  other: "अन्य",
  retailer: "खुदरा विक्रेता",
  wholesaler: "थोक विक्रेता",
  manufacturer: "निर्माता",
  service_provider: "सेवा प्रदाता",
  gst_configuration: "GST कॉन्फ़िगरेशन",
  enabled: "सक्रिय",
  disabled: "निष्क्रिय",
  gstin_number: "GSTIN नंबर",
  gstin_placeholder: "22AAAAA0000A1Z5",
  gst_registration_date: "GST पंजीकरण तिथि",
  default_cgst: "डिफ़ॉल्ट CGST (%)",
  default_sgst: "डिफ़ॉल्ट SGST (%)",
  default_igst: "डिफ़ॉल्ट IGST (%)",
  auto_sync: "GST पोर्टल के साथ चालानों को स्वतः सिंक करें",
  business_settings: "व्यवसाय सेटिंग्स",
  manage_business_preferences: "अपने व्यवसाय की प्राथमिकताएँ और कॉन्फ़िगरेशन प्रबंधित करें",
  general_settings: "सामान्य सेटिंग्स",
  configure_general_settings: "मूल व्यवसाय सेटिंग्स कॉन्फ़िगर करें",
  language: "भाषा",
  select_language: "भाषा चुनें",
  currency: "मुद्रा",
  select_currency: "मुद्रा चुनें",
  timezone: "समय क्षेत्र",
  select_timezone: "समय क्षेत्र चुनें",
  notifications: "सूचनाएँ",
  manage_notification_preferences: "अपनी सूचना प्राथमिकताएँ प्रबंधित करें",
  low_stock_alerts: "कम स्टॉक अलर्ट",
  low_stock_description: "स्टॉक कम होने पर सूचना प्राप्त करें",
  expiring_items: "समाप्ति के करीब आइटम",
  expiring_items_description: "समाप्ति के नज़दीक आइटम्स के बारे में सूचना प्राप्त करें",
  order_updates: "ऑर्डर अपडेट्स",
  order_updates_description: "नए ऑर्डर और स्थिति परिवर्तन की सूचना प्राप्त करें",
  save_changes: "परिवर्तन सहेजें",
  saving: "सहेजा जा रहा है...",
  cancel: "रद्द करें",
  create_profile_btn: "प्रोफ़ाइल बनाएँ",
  yes: "हाँ",
  no: "नहीं",
  n_a: "लागू नहीं",
  settings_saved_successfully: "सेटिंग्स सफलतापूर्वक सहेजी गईं",
  failed_to_save_settings: "सेटिंग्स सहेजने में विफल",
  failed_to_load_settings: "सेटिंग्स लोड करने में विफल",
  profile_updated: "प्रोफ़ाइल सफलतापूर्वक अपडेट हुई",
  business_profile_created: "व्यवसाय प्रोफ़ाइल सफलतापूर्वक बनाई गई!",
  error_saving: "सहेजते समय एक त्रुटि हुई",
  error_creating: "प्रोफ़ाइल बनाते समय एक त्रुटि हुई",
  could_not_fetch_business_profile: "व्यवसाय प्रोफ़ाइल प्राप्त नहीं की जा सकी",
  business_profile_not_found: "व्यवसाय प्रोफ़ाइल नहीं मिली",
  not_provided: "प्रदान नहीं किया गया",
  business_label: "व्यवसाय"
},

  business_settings_page: {
    business_settings: "व्यापार सेटिंग्स",
    manage_business_preferences: "अपनी व्यापार प्राथमिकताओं और कॉन्फ़िगरेशन को प्रबंधित करें",
    general_settings: "सामान्य सेटिंग्स",
    configure_general_settings: "बुनियादी व्यापार सेटिंग्स को कॉन्फ़िगर करें",
    language: "भाषा",
    currency: "मुद्रा",
    select_currency: "मुद्रा चुनें",
    timezone: "समय क्षेत्र",
    select_timezone: "समय क्षेत्र चुनें",
    notifications: "सूचनाएं",
    manage_notification_preferences: "अपनी अधिसूचना प्राथमिकताओं को प्रबंधित करें",
    low_stock_alerts: "कम स्टॉक अलर्ट",
    low_stock_description: "इन्वेंट्री कम होने पर सूचित करें",
    expiring_items: "समाप्त होने वाली वस्तुएं",
    expiring_items_description: "समाप्ति के करीब वस्तुओं के बारे में सूचित करें",
    order_updates: "ऑर्डर अपडेट",
    order_updates_description: "नए ऑर्डर और स्थिति परिवर्तन के बारे में सूचित करें",
    saving: "सहेज रहा है...",
    save_changes: "परिवर्तन सहेजें",
    failed_to_load_settings: "सेटिंग्स लोड करने में विफल",
    settings_saved_successfully: "सेटिंग्स सफलतापूर्वक सहेजी गईं",
    failed_to_save_settings: "सेटिंग्स सहेजने में विफल"
  },
  orders_page: {
      title: 'ऑर्डर',
      description: 'अपने सभी ऑर्डर प्रबंधित करें',
      create_new_order: 'नया ऑर्डर बनाएं',
      total_orders: 'कुल ऑर्डर',
      pending_orders: 'लंबित ऑर्डर',
      completed_orders: 'पूर्ण ऑर्डर',
      direct_sales: 'सीधी बिक्री',
      search_placeholder: 'ऑर्डर आईडी या ग्राहक नाम से खोजें...',
      filter_all: 'सभी',
      filter_pending: 'लंबित',
      filter_completed: 'पूर्ण',
      no_orders: 'कोई ऑर्डर नहीं',
      no_orders_desc: 'कोई ऑर्डर नहीं मिला',
      delete_confirmation: 'क्या आप इस ऑर्डर को हटाना चाहते हैं?',
      col_order_id: 'ऑर्डर आईडी',
      col_customer_name: 'ग्राहक का नाम',
      guest: 'अतिथि',
      col_order_status: 'ऑर्डर की स्थिति',
      standard: 'मानक',
      col_amount: 'राशि',
      total: 'कुल',
      col_actions: 'कार्रवाई',
      wire: 'वायर',
      error_loading_sample: 'लोड हो रहा है... नमूना डेटा दिखा रहा है'
    },
    profile_settings: {
    title: 'सेटिंग्स',
    description: 'अपने खाते और प्लेटफ़ॉर्म प्राथमिकताओं को प्रबंधित करें।',
    my_profile: 'मेरी प्रोफ़ाइल',
    my_profile_desc: 'व्यक्तिगत जानकारी और अवतार',
    preferences: 'प्राथमिकताएं',
    preferences_desc: 'थीम, भाषा और सूचनाएं',
    security_privacy: 'सुरक्षा और गोपनीयता',
    security_privacy_desc: 'पासवर्ड और एक्सेस सुरक्षा',
    active_sessions: 'सक्रिय सत्र',
    active_sessions_desc: 'लॉग इन किए गए उपकरणों को प्रबंधित करें',
    sign_out: 'साइन आउट',
    profile_details: 'प्रोफ़ाइल विवरण',
    profile_details_desc: 'अपनी फोटो और व्यक्तिगत जानकारी अपडेट करें।',
    verified_account: 'सत्यापित खाता',
    premium_plan: 'प्रीमियम योजना',
    first_name: 'पहला नाम',
    last_name: 'अंतिम नाम',
    email_address: 'ईमेल पता',
    saving: 'सहेज रहा है...',
    save_profile_changes: 'प्रोफ़ाइल परिवर्तन सहेजें',
    preferences_title: 'प्राथमिकताएं',
    preferences_page_desc: 'प्लेटफ़ॉर्म पर अपने अनुभव को अनुकूलित करें।',
    appearance: 'दिखावट',
    theme: 'थीम',
    select_theme: 'थीम चुनें',
    light_mode: 'लाइट मोड',
    dark_mode: 'डार्क मोड',
    system_default: 'सिस्टम डिफ़ॉल्ट',
    display_language: 'प्रदर्शन भाषा',
    select_language: 'भाषा चुनें',
    notifications: 'सूचनाएं',
    email_notifications: 'ईमेल सूचनाएं',
    email_notifications_desc: 'ईमेल के माध्यम से अपडेट प्राप्त करें',
    push_notifications: 'पुश सूचनाएं',
    push_notifications_desc: 'ब्राउज़र सूचनाएं प्राप्त करें',
    sms_notifications: 'एसएमएस सूचनाएं',
    sms_notifications_desc: 'एसएमएस के माध्यम से अपडेट प्राप्त करें',
    save_preferences: 'प्राथमिकताएं सहेजें',
    security_privacy_header: 'सुरक्षा और गोपनीयता',
    security_privacy_header_desc: 'एक सुरक्षित पासवर्ड के साथ अपने खाते को मजबूत करें।',
    current_password: 'वर्तमान पासवर्ड',
    new_password: 'नया पासवर्ड',
    confirm_password: 'पासवर्ड की पुष्टि करें',
    updating: 'अपडेट हो रहा है...',
    change_password: 'पासवर्ड बदलें',
    advanced_security: 'उन्नत सुरक्षा',
    advanced_security_desc: 'इस खाते में सभी लॉगिन प्रयासों के लिए बहु-कारक प्रमाणीकरण की आवश्यकता है।',
    enable_2fa: '2FA प्रमाणीकरण सक्षम करें →',
    customization_underway: 'अनुकूलन चल रहा है',
    customization_underway_desc: 'हम आपको अपने अनुभव पर पूर्ण नियंत्रण देने के लिए विस्तृत अधिसूचना नियंत्रण और उपकरण प्रबंधन का निर्माण कर रहे हैं।'
  },

  // Inventory Management
  inventory: {
    items: 'आइटम',
    item: 'आइटम',
    product: 'उत्पाद',
    service: 'सेवा',
    sku: 'एसकेयू',
    barcode: 'बारकोड',
    category: 'श्रेणी',
    brand: 'ब्रांड',
    unit: 'इकाई',
    quantity: 'मात्रा',
    price: 'कीमत',
    cost: 'लागत',
    sellingPrice: 'बिक्री मूल्य',
    purchasePrice: 'खरीद मूल्य',
    stock: 'स्टॉक',
    lowStock: 'कम स्टॉक',
    outOfStock: 'स्टॉक खत्म',
    inStock: 'स्टॉक में',
    stockAlert: 'स्टॉक अलर्ट',
    reorderLevel: 'पुनः ऑर्डर स्तर',
    maxStock: 'अधिकतम स्टॉक',
    minStock: 'न्यूनतम स्टॉक',
    addItem: 'आइटम जोड़ें',
    editItem: 'आइटम संपादित करें',
    deleteItem: 'आइटम डिलीट करें',
    bulkImport: 'बल्क इम्पोर्ट',
    bulkExport: 'बल्क एक्सपोर्ट',
    stockUpdate: 'स्टॉक अपडेट',
    stockAdjustment: 'स्टॉक समायोजन',
    stockTransfer: 'स्टॉक ट्रांसफर'
  },

  // Time formatting
  time: {
    justNow: 'अभी',
    minutesAgo: '{{count}} मिनट पहले',
    hoursAgo: '{{count}} घंटे पहले',
    daysAgo: '{{count}} दिन पहले',
    weeksAgo: '{{count}} सप्ताह पहले',
    monthsAgo: '{{count}} महीने पहले',
    yearsAgo: '{{count}} साल पहले'
  },

  // Pluralization
  items: {
    one: '{{count}} आइटम',
    other: '{{count}} आइटम'
  },

  customers: {
    one: '{{count}} ग्राहक',
    other: '{{count}} ग्राहक'
  },

  orders: {
    one: '{{count}} ऑर्डर',
    other: '{{count}} ऑर्डर'
  },
  dashboard: {
    "dashboard": "डैशबोर्ड",
    "business_overview": "व्यापार अवलोकन",
    "action_required": "कार्रवाई आवश्यक है",
    "profile_incomplete_message": "आपकी व्यावसायिक प्रोफ़ाइल अधूरी है। कृपया जारी रखने के लिए आवश्यक विवरण प्रदान करें।",
    "complete_profile": "प्रोफ़ाइल पूरी करें",
    "quick_actions": "त्वरित कार्रवाइयां",
    "add_sale": "बिक्री जोड़ें",
    "manage_stock": "स्टॉक प्रबंधित करें",
    "view_orders": "आदेश देखें",
    "todays_overview": "आज का अवलोकन",
    "weeks_overview": "इस सप्ताह का अवलोकन",
    "months_overview": "इस महीने का अवलोकन",
    "low_stock": "कम स्टॉक",
    "business_management": "व्यापार प्रबंधन",
    "inventory_management_subtitle": "उत्पादों और स्टॉक का प्रबंधन करें",
    "order_management_subtitle": "आदेशों को ट्रैक और पूरा करें",
    "purchase_management_subtitle": "खरीद को ट्रैक और प्रबंधित करें",
    "customer_management_subtitle": "ग्राहक संबंधों का प्रबंधन करें",
    "supplier_management_subtitle": "आपूर्तिकर्ता संबंधों का प्रबंधन करें",
    "business_analytics_subtitle": "प्रदर्शन मीट्रिक्स देखें"
  },
  settings: {
    "settingsTitle": "सेटिंग्स",
    "inventorySection": "इन्वेंटरी",
    "lowStockThresholdLabel": "कम स्टॉक थ्रेसहोल्ड",
    "lowStockThresholdDescription": "अलर्ट ट्रिगर होने से पहले न्यूनतम स्टॉक स्तर।",
    "stockAlertsLabel": "स्टॉक अलर्ट",
    "stockAlertsDescription": "कम स्टॉक के लिए सूचनाएं प्राप्त करें।",
    "autoReorderLabel": "ऑटो री-ऑर्डर",
    "autoReorderDescription": "स्टॉक कम होने पर स्वचालित रूप से खरीद ऑर्डर बनाएं।",
    "ordersSection": "आदेश",
    "autoConfirmOrdersLabel": "आदेशों की स्वतः पुष्टि करें",
    "autoConfirmOrdersDescription": "आने वाले आदेशों को स्वचालित रूप से स्वीकृत और संसाधित करें।",
    "defaultPaymentMethodLabel": "डिफ़ॉल्ट भुगतान विधि",
    "defaultPaymentMethodDescription": "नए आदेशों के लिए एक डिफ़ॉल्ट भुगतान विधि सेट करें।",
    "orderNumberPrefixLabel": "ऑर्डर नंबर उपसर्ग",
    "orderNumberPrefixDescription": "सभी ऑर्डर नंबरों के लिए एक कस्टम उपसर्ग (जैसे, 'ORD-').",
    "invoicingSection": "चालान-प्रक्रिया",
    "autoGenerateInvoicesLabel": "स्वचालित रूप से चालान बनाएं",
    "autoGenerateInvoicesDescription": "प्रत्येक आदेश के लिए स्वचालित रूप से एक नया चालान बनाएं।",
    "invoiceNumberPrefixLabel": "चालान संख्या उपसर्ग",
    "invoiceNumberPrefixDescription": "सभी चालान नंबरों के लिए एक कस्टम उपसर्ग (जैसे, 'INV-').",
    "defaultTaxRateLabel": "डिफ़ॉल्ट कर दर (%)",
    "defaultTaxRateDescription": "नए चालानों पर लागू डिफ़ॉल्ट कर दर।",
    "paymentTermsLabel": "भुगतान की शर्तें",
    "paymentTermsDescription": "चालानों के लिए डिफ़ॉल्ट भुगतान शर्तें (जैसे, 'नेट 30').",
    "reportingSection": "रिपोर्टिंग",
    "autoEmailReportsLabel": "रिपोर्ट स्वचालित रूप से ईमेल करें",
    "autoEmailReportsDescription": "अपने ईमेल पते पर निर्धारित रिपोर्ट भेजें।",
    "defaultReportPeriodLabel": "डिफ़ॉल्ट रिपोर्ट अवधि",
    "defaultReportPeriodDescription": "सभी रिपोर्ट के लिए एक डिफ़ॉल्ट अवधि सेट करें (जैसे, 'मासिक', 'साप्ताहिक')।",
    "reportFormatLabel": "रिपोर्ट प्रारूप",
    "reportFormatDescription": "रिपोर्ट के लिए डिफ़ॉल्ट फ़ाइल प्रारूप चुनें (जैसे, 'पीडीएफ', 'सीएसवी')।",
    "loadSettingsError": "सेटिंग्स लोड करने में विफल: {{message}}",
    "updateFailedError": "अपडेट विफल",
    "invalidInputError": "अमान्य इनपुट",
    "enterValidNumberError": "कृपया एक मान्य संख्या दर्ज करें।",
    "selectOption": "चुनें",
    "paymentMethodCash": "नकद",
    "paymentMethodCard": "कार्ड",
    "paymentMethodUPI": "UPI",
    "paymentMethodBankTransfer": "बैंक ट्रांसफर",
    "reportPeriodDaily": "दैनिक",
    "reportPeriodWeekly": "साप्ताहिक",
    "reportPeriodMonthly": "मासिक",
    "reportPeriodQuarterly": "त्रैमासिक",
    "reportFormatPDF": "पीडीएफ",
    "reportFormatExcel": "एक्सेल",
    "reportFormatCSV": "सीएसवी",
    "enterValuePlaceholder": "मान दर्ज करें"
  },
  businessProfile: {
    "business_profile": "व्यवसाय प्रोफ़ाइल",
    "no_business_profile": "कोई बिजनेस प्रोफाइल नहीं",
    "no_business_profile_description": "ऐसा लगता है कि आपने अभी तक अपनी बिजनेस प्रोफाइल सेट नहीं की है।",
    "create_business_profile": "बिजनेस प्रोफाइल बनाएं",
    "flower_vendor": "फूल विक्रेता",
    "grocery_store": "किराने की दुकान",
    "textile_shop": "कपड़े की दुकान",
    "hardware_store": "हार्डवेयर की दुकान",
    "electronics_shop": "इलेक्ट्रॉनिक्स की दुकान"
  },
  businessSettings: {
    "businessSettings": "व्यापार सेटिंग्स",
    "currency": "मुद्रा",
    "setCurrency": "अपने व्यवसाय के लिए डिफ़ॉल्ट मुद्रा सेट करें।",
    "language": "भाषा",
    "setLanguage": "अपने खाते के लिए भाषा सेट करें।",
    "timezone": "समय क्षेत्र",
    "setTimezone": "अपने व्यवसाय के लिए समय क्षेत्र सेट करें।",
    "notifications": "सूचनाएं",
    "lowStockAlerts": "कम स्टॉक अलर्ट",
    "lowStockDescription": "कम स्टॉक आइटम के लिए अलर्ट प्राप्त करें।",
    "expiringItems": "समाप्त होने वाली वस्तुएं",
    "expiringItemsDescription": "उनकी समाप्ति तिथि के निकट आने वाली वस्तुओं के लिए अलर्ट प्राप्त करें।",
    "orderUpdates": "ऑर्डर अपडेट",
    "orderUpdatesDescription": "नए ऑर्डर और ऑर्डर स्थिति परिवर्तनों के लिए अलर्ट प्राप्त करें।",
    "select": "चुनें",
    "updateFailed": "अपडेट विफल",
    "loadingError": "सेटिंग्स लोड करने में विफल",
    "inr": "भारतीय रुपया (INR)",
    "usd": "अमेरिकी डॉलर (USD)",
    "en": "अंग्रेज़ी",
    "hi": "हिन्दी",
    "te": "तेलुगू",
    "ta": "तमिल",
    "kn": "कन्नड़",
    "ml": "मलयालम",
    "kolkata": "एशिया/कोलकाता"
  },
  profile: {
    "profile": "प्रोफ़ाइल",
    "manage_your_account_settings": "अपनी खाता सेटिंग्स प्रबंधित करें",
    "active": "सक्रिय",
    "business": "व्यवसाय",
    "business_profile": "व्यवसाय प्रोफ़ाइल",
    "business_settings": "व्यवसाय सेटिंग्स",
    "subscription": "अंशदान",
    "reports_and_analytics": "रिपोर्ट और विश्लेषण",
    "account": "खाता",
    "edit_profile": "प्रोफ़ाइल संपादित करें",
    "security_and_privacy": "सुरक्षा और गोपनीयता",
    "settings": "सेटिंग्स",
    "preferences": "वरीयताएँ",
    "help_and_support": "सहायता और समर्थन",
    "about_soma": "सोमा के बारे में",
    "sign_out": "साइन आउट करें",
    "logout": "लॉग आउट",
    "are_you_sure_you_want_to_logout": "क्या आप वाकई लॉग आउट करना चाहते हैं?"
  },
  dashboard: {
    dashboard: "डैशबोर्ड",
    business_overview: "व्यापार अवलोकन",
    action_required: "कार्रवाई आवश्यक",
    profile_incomplete_message: "आपका व्यवसाय प्रोफ़ाइल अधूरा है। जारी रखने के लिए कृपया आवश्यक विवरण प्रदान करें।",
    complete_profile: "प्रोफ़ाइल पूरा करें",
    quick_actions: "त्वरित कार्रवाई",
    add_sale: "बिक्री जोड़ें",
    manage_stock: "स्टॉक प्रबंधित करें",
    view_orders: "ऑर्डर देखें",
    todays_overview: "आज का अवलोकन",
    weeks_overview: "इस सप्ताह का अवलोकन",
    months_overview: "इस महीने का अवलोकन",
    low_stock: "कम स्टॉक",
    business_management: "व्यापार प्रबंधन",
    inventory_management_subtitle: "उत्पादों और स्टॉक का प्रबंधन करें",
    order_management_subtitle: "आदेशों को ट्रैक और पूरा करें",
    purchase_management_subtitle: "खरीद को ट्रैक और प्रबंधित करें",
    customer_management_subtitle: "ग्राहक संबंधों का प्रबंधन करें",
    supplier_management_subtitle: "आपूर्तिकर्ता संबंधों का प्रबंधन करें",
    business_analytics_subtitle: "प्रदर्शन मीट्रिक्स देखें",
    welcome_back: "वापसी पर स्वागत है",
    orders_need_attention: "ऑर्डर पर ध्यान देने की आवश्यकता है",
    total_revenue: "कुल राजस्व",
    active_orders: "सक्रिय ऑर्डर",
    stock_value: "स्टॉक मूल्य",
    total_customers: "कुल ग्राहक",
    live: "लाइव",
    monthly_sales: "मासिक बिक्री",
    view_details: "विवरण देखें",
    recent_orders: "हाल के ऑर्डर",
    view_all: "सभी देखें",
    order_id: "ऑर्डर आईडी",
    customer: "ग्राहक",
    amount: "राशि",
    status: "स्थिति",
    important_tasks: "महत्वपूर्ण कार्य",
    in_stock: "स्टॉक में",
    buy_more: "और खरीदें",
    manage_inventory: "इन्वेंटरी प्रबंधन",
    goals: "लक्ष्य",
    sales_goal: "बिक्री लक्ष्य",
    revenue_goal: "राजस्व लक्ष्य",
    search_placeholder: "ऑर्डर, ग्राहक या उत्पाद खोजें...",
    loading: "लोड हो रहा है..."
  },
  analytics: {
    title: "एनालिटिक्स",
    subtitle: "व्यवसाय प्रदर्शन अंतर्दृष्टि",
    last_7_days: "पिछले 7 दिन",
    last_30_days: "पिछले 30 दिन",
    last_3_months: "पिछले 3 महीने",
    business_reports: "व्यापार रिपोर्ट",
    sales_forecast: "बिक्री पूर्वानुमान",
    reports_library: "रिपोर्ट लाइब्रेरी",
    total_revenue: "कुल राजस्व",
    average_order_value: "औसत ऑर्डर मूल्य",
    growth_rate: "विकास दर",
    total_orders: "कुल ऑर्डर",
    sales_by_channel: "चैनल द्वारा बिक्री",
    sales_breakdown: "बिक्री का विवरण",
    online_sales: "ऑनलाइन बिक्री",
    store_sales: "स्टोर बिक्री",
    wholesale_sales: "थोक बिक्री",
    ai_suggestions: "एआई सुझाव",
    ai_insight_1: "इन्वेंटरी अनुकूलन",
    ai_insight_1_desc: "स्टॉकआउट को रोकने के लिए 'प्रीमियम सिल्क साड़ी' का रीऑर्डर करने पर विचार करें।",
    next_month: "अगले महीने",
    next_3_months: "अगले 3 महीने",
    accuracy: "सटीकता",
    sales_growth: "बिक्री वृद्धि",
    sales_growth_subtitle: "पिछले महीने की तुलना में अनुमानित वृद्धि",
    search_reports: "रिपोर्ट टेम्प्लेट खोजें...",
    reports_available: "रिपोर्ट उपलब्ध",
    no_reports: "कोई रिपोर्ट नहीं मिली",
    no_reports_desc: "विभिन्न खोज शब्दों का प्रयास करें या एक नई कस्टम रिपोर्ट बनाएं।",
    report_name: "रिपोर्ट का नाम",
    system_default: "सिस्टम डिफ़ॉल्ट",
    description: "विवरण",
    actions: "कार्रवाई",
    edit: "संपादित करें",
    generate: "उत्पन्न करें"
  },
  // business: {
  //   profile: "Business Profile",
  //   edit_profile: "Edit Profile",
  //   create_profile: "Create Business Profile",
  //   edit_business_profile: "Edit Business Profile",
  //   create_business_profile: "Create Business Profile",
  //   no_profile_found: "No Business Profile Found",
  //   no_business_profile: "No Business Profile Found",
  //   no_business_profile_description: "You haven't set up your business profile yet. Create one to unlock all features.",
  //   go_back: "Go Back",
  //   basic_info: "Basic Information",
  //   business_name: "Business Name",
  //   enter_name: "Enter business name",
  //   business_type: "Business Type",
  //   select_type: "Select business type",
  //   email: "Email",
  //   phone: "Phone",
  //   address: "Address",
  //   enter_address: "Enter complete address",
  //   category: "Category",
  //   select_category: "Select category",
  //   annual_turnover: "Annual Turnover",
  //   select_turnover: "Select turnover range",
  //   gst_registered: "GST Registered",
  //   gst_number: "GST Number",
  //   registration_date: "Registration Date",
  //   flower_vendor: "Flower Vendor",
  //   grocery_store: "Grocery Store",
  //   textile_shop: "Textile Shop",
  //   hardware_store: "Hardware Store",
  //   electronics_shop: "Electronics Shop",
  //   other: "Other",
  //   retailer: "Retailer",
  //   wholesaler: "Wholesaler",
  //   manufacturer: "Manufacturer",
  //   service_provider: "Service Provider",
  //   gst_configuration: "GST Configuration",
  //   enabled: "Enabled",
  //   disabled: "Disabled",
  //   gstin_number: "GSTIN Number",
  //   default_cgst: "Default CGST (%)",
  //   default_sgst: "Default SGST (%)",
  //   default_igst: "Default IGST (%)",
  //   auto_sync: "Auto-sync invoices with GST portal",
  //   business_settings: "Business Settings",
  //   manage_business_preferences: "Manage your business preferences and configurations",
  //   general_settings: "General Settings",
  //   configure_general_settings: "Configure basic business settings",
  //   language: "Language",
  //   select_language: "Select Language",
  //   currency: "Currency",
  //   select_currency: "Select Currency",
  //   timezone: "Timezone",
  //   select_timezone: "Select Timezone",
  //   notifications: "Notifications",
  //   manage_notification_preferences: "Manage your notification preferences",
  //   low_stock_alerts: "Low Stock Alerts",
  //   low_stock_description: "Get notified when inventory runs low",
  //   expiring_items: "Expiring Items",
  //   expiring_items_description: "Get notified about items nearing expiration",
  //   order_updates: "Order Updates",
  //   order_updates_description: "Get notified about new orders and status changes",
  //   save_changes: "Save Changes",
  //   saving: "Saving...",
  //   cancel: "Cancel",
  //   create_profile_btn: "Create Profile",
  //   yes: "Yes",
  //   no: "No",
  //   n_a: "N/A",
  //   settings_saved_successfully: "Settings saved successfully",
  //   failed_to_save_settings: "Failed to save settings",
  //   failed_to_load_settings: "Failed to load settings",
  //   profile_updated: "Profile updated successfully",
  //   business_profile_created: "Business profile created successfully!",
  //   error_saving: "An error occurred while saving",
  //   error_creating: "An error occurred while creating profile",
  //   could_not_fetch_business_profile: "Could not fetch business profile",
  //   business_profile_not_found: "Business profile not found",
  //   not_provided: "Not provided",
  //   business_label: "Business"
  // },

  security_page: {
    hero_badge: "Security",
    hero_title: "Bank-Grade Security",
    hero_subtitle: "for Your Business.",
    hero_desc: "Your business data is protected with enterprise-grade security measures. We take security seriously and continuously invest in keeping your data safe.",
    measures_title: "Our Security Measures",
    measures_desc: "Multiple layers of security protect your data at every level.",
    compliance_title: "Compliance & Certifications",
    compliance_desc: "We maintain the highest standards of compliance and security certifications.",
    best_practices_title: "Security Best Practices",
    best_practices_desc: "Help us keep your account secure by following these best practices:",
    reporting_title: "Reporting Security Issues",
    reporting_desc: "If you discover a security vulnerability or have concerns about security, please report it to us immediately.",
    responsible_disclosure: "Responsible Disclosure",
    responsible_disclosure_desc: "We appreciate responsible disclosure of security vulnerabilities. Please email security details to:",
    contact_team: "Contact Security Team",
    view_privacy: "View Privacy Policy",
    priority_title: "Your Security is Our Priority",
    priority_desc: "We continuously invest in security infrastructure and best practices to protect your business data. Have questions about security? We're here to help.",
    feature_encryption: "End-to-End Encryption",
    feature_encryption_desc: "All data is encrypted using AES-256 encryption both in transit (TLS 1.3) and at rest. Your business data is protected with bank-grade security standards.",
    feature_audits: "Regular Security Audits",
    feature_audits_desc: "We conduct regular security audits, penetration testing, and vulnerability assessments to identify and address potential security issues proactively.",
    feature_access: "Access Controls",
    feature_access_desc: "Role-based access control (RBAC) ensures that users only have access to the data and features they need. Multi-factor authentication (MFA) is available for enhanced security.",
    feature_backups: "Data Backups",
    feature_backups_desc: "Automated daily backups ensure your data is safe. Backups are encrypted and stored in geographically distributed data centers for redundancy and disaster recovery.",
    feature_compliance: "Compliance & Certifications",
    feature_compliance_desc: "We comply with the Digital Personal Data Protection Act (DPDP Act) and maintain SOC 2 Type II compliance. Regular compliance audits ensure we meet the highest standards.",
    feature_incident: "Incident Response",
    feature_incident_desc: "Our security team monitors systems 24/7 and has a comprehensive incident response plan. We notify affected users promptly in the event of any security incident.",
    practice_passwords: "Use strong, unique passwords for your Soma account",
    practice_mfa: "Enable multi-factor authentication (MFA) for added security",
    practice_access: "Regularly review and update user access permissions",
    practice_contact: "Keep your contact information up to date for security notifications",
    practice_logout: "Log out from shared or public computers",
    practice_report: "Report any suspicious activity immediately to security@soma.com",
    comp_dpdp: "DPDP Act Compliance",
    comp_dpdp_desc: "Full compliance with India's Digital Personal Data Protection Act",
    comp_soc2: "SOC 2 Type II",
    comp_soc2_desc: "Certified for security, availability, and confidentiality",
    comp_iso: "ISO 27001",
    comp_iso_desc: "Information security management system certified",
    comp_gst: "GST Compliance",
    comp_gst_desc: "Secure handling of tax data per Indian regulations",
    compliance_disclaimer: "* Security standards and certifications are part of our development roadmap and compliance goals.",
    reporting_ack: "We will acknowledge receipt within 24 hours and work with you to address the issue promptly."
  },
  subscription_page: {
    subscription: "Subscription",
    manage_subscription: "Manage your subscription plan and billing details.",
    current_plan: "Current Plan",
    gst_settings: "GST Settings",
    gst_settings_desc: "Manage your GST settings and enable GST features for your business compliance and invoicing.",
    available_plans: "Available Plans",
    plan_name: "Plan Name",
    free_tier: "Free Tier",
    included_features: "Included Features",
    no_active_subscription: "No active subscription found.",
    loading: "Loading...",
    configure_gst: "Configure GST",
    processing: "Processing...",
    upgrade_plan: "Upgrade Plan",
    error_fetch_subscription: "Failed to fetch subscription details.",
    error_generic_subscription: "An error occurred while fetching subscription details.",
    error_select_plan: "Please select a plan to upgrade.",
    success_upgrade: "Subscription upgraded successfully!",
    error_upgrade: "Failed to upgrade subscription.",
    error_upgrade_generic: "An error occurred while upgrading subscription.",
    error_business_not_found: "Business profile not found. Please create one first.",
    error_fetch_business: "Failed to fetch business details."
  },



  security_page: {
    hero_badge: "सुरक्षा",
    hero_title: "बैंक-स्तरीय सुरक्षा",
    hero_subtitle: "आपके व्यवसाय के लिए।",
    hero_desc: "आपका व्यावसायिक डेटा उद्यम-स्तरीय सुरक्षा उपायों के साथ सुरक्षित है। हम सुरक्षा को गंभीरता से लेते हैं और आपके डेटा को सुरक्षित रखने के लिए लगातार निवेश करते हैं।",
    measures_title: "हमारे सुरक्षा उपाय",
    measures_desc: "सुरक्षा की कई परतें हर स्तर पर आपके डेटा की सुरक्षा करती हैं।",
    compliance_title: "अनुपालन और प्रमाणन",
    compliance_desc: "हम अनुपालन और सुरक्षा प्रमाणन के उच्चतम मानकों को बनाए रखते हैं।",
    best_practices_title: "सुरक्षा सर्वोत्तम प्रथाएं",
    best_practices_desc: "इन सर्वोत्तम प्रथाओं का पालन करके अपने खाते को सुरक्षित रखने में हमारी सहायता करें:",
    reporting_title: "सुरक्षा मुद्दों की रिपोर्टिंग",
    reporting_desc: "यदि आपको कोई सुरक्षा भेद्यता मिलती है या सुरक्षा के बारे में चिंता है, तो कृपया हमें तुरंत रिपोर्ट करें।",
    responsible_disclosure: "जिम्मेदार प्रकटीकरण",
    responsible_disclosure_desc: "हम सुरक्षा कमजोरियों के जिम्मेदार प्रकटीकरण की सराहना करते हैं। कृपया सुरक्षा विवरण ईमेल करें:",
    contact_team: "सुरक्षा टीम से संपर्क करें",
    view_privacy: "गोपनीयता नीति देखें",
    priority_title: "आपकी सुरक्षा हमारी प्राथमिकता है",
    priority_desc: "हम आपके व्यावसायिक डेटा की सुरक्षा के लिए सुरक्षा अवसंरचना और सर्वोत्तम प्रथाओं में लगातार निवेश करते हैं। सुरक्षा के बारे में प्रश्न हैं? हम यहाँ मदद करने के लिए हैं।",
    feature_encryption: "एंड-टू-एंड एन्क्रिप्शन",
    feature_encryption_desc: "सभी डेटा एईएस-256 एन्क्रिप्शन का उपयोग करके एन्क्रिप्ट किया गया है। आपका व्यावसायिक डेटा बैंक-ग्रेड सुरक्षा मानकों के साथ सुरक्षित है।",
    feature_audits: "नियमित सुरक्षा ऑडिट",
    feature_audits_desc: "हम संभावित सुरक्षा मुद्दों को सक्रिय रूप से पहचानने और संबोधित करने के लिए नियमित सुरक्षा ऑडिट, प्रवेश परीक्षण और भेद्यता मूल्यांकन करते हैं।",
    feature_access: "एक्सेस कंट्रोल",
    feature_access_desc: "भूमिका-आधारित अभिगम नियंत्रण (RBAC) यह सुनिश्चित करता है कि उपयोगकर्ताओं के पास केवल उन डेटा और सुविधाओं तक पहुंच हो जिनकी उन्हें आवश्यकता है। बढ़ी हुई सुरक्षा के लिए मल्टी-फैक्टर ऑथेंटिकेशन (MFA) उपलब्ध है।",
    feature_backups: "डेटा बैकअप",
    feature_backups_desc: "स्वचालित दैनिक बैकअप सुनिश्चित करते हैं कि आपका डेटा सुरक्षित है। बैकअप एन्क्रिप्टेड हैं और अतिरेक और आपदा वसूली के लिए भौगोलिक रूप से वितरित डेटा केंद्रों में संग्रहीत हैं।",
    feature_compliance: "अनुपालन और प्रमाणन",
    feature_compliance_desc: "हम डिजिटल पर्सनल डेटा प्रोटेक्शन एक्ट (DPDP एक्ट) का अनुपालन करते हैं और SOC 2 टाइप II अनुपालन बनाए रखते हैं। नियमित अनुपालन ऑडिट सुनिश्चित करते हैं कि हम उच्चतम मानकों को पूरा करते हैं।",
    feature_incident: "घटना प्रतिक्रिया",
    feature_incident_desc: "हमारी सुरक्षा टीम सिस्टम की 24/7 निगरानी करती है और उसके पास एक व्यापक घटना प्रतिक्रिया योजना है। हम किसी भी सुरक्षा घटना की स्थिति में प्रभावित उपयोगकर्ताओं को तुरंत सूचित करते हैं।",
    practice_passwords: "अपने सोमा खाते के लिए मजबूत, अद्वितीय पासवर्ड का उपयोग करें",
    practice_mfa: "अतिरिक्त सुरक्षा के लिए मल्टी-फैक्टर ऑथेंटिकेशन (MFA) सक्षम करें",
    practice_access: "उपयोगकर्ता पहुँच अनुमतियों की नियमित समीक्षा और अद्यतन करें",
    practice_contact: "सुरक्षा सूचनाओं के लिए अपनी संपर्क जानकारी अपडेट रखें",
    practice_logout: "साझा या सार्वजनिक कंप्यूटर से लॉग आउट करें",
    practice_report: "security@soma.com पर तुरंत किसी भी संदिग्ध गतिविधि की रिपोर्ट करें",
    comp_dpdp: "डीपीडीपी अधिनियम अनुपालन",
    comp_dpdp_desc: "भारत के डिजिटल व्यक्तिगत डेटा संरक्षण अधिनियम का पूर्ण अनुपालन",
    comp_soc2: "SOC 2 टाइप II",
    comp_soc2_desc: "सुरक्षा, उपलब्धता और गोपनीयता के लिए प्रमाणित",
    comp_iso: "आईएसओ 27001",
    comp_iso_desc: "सूचना सुरक्षा प्रबंधन प्रणाली प्रमाणित",
    comp_gst: "जीएसटी अनुपालन",
    comp_gst_desc: "भारतीय नियमों के अनुसार कर डेटा का सुरक्षित प्रबंधन",
    compliance_disclaimer: "* सुरक्षा मानक और प्रमाणन हमारे विकास रोडमैप और अनुपालन लक्ष्यों का हिस्सा हैं।",
    reporting_ack: "हम 24 घंटे के भीतर प्राप्ति स्वीकार करेंगे और समस्या का तुरंत समाधान करने के लिए आपके साथ काम करेंगे।"
  },
  subscription_page: {
    subscription: "सदस्यता",
    manage_subscription: "अपनी सदस्यता योजना और बिलिंग विवरण प्रबंधित करें।",
    current_plan: "वर्तमान योजना",
    gst_settings: "जीएसटी सेटिंग्स",
    gst_settings_desc: "अपनी जीएसटी सेटिंग्स प्रबंधित करें और अपने व्यवसाय अनुपालन और चालान के लिए जीएसटी सुविधाओं को सक्षम करें।",
    available_plans: "उपलब्ध योजनाएं",
    plan_name: "योजना का नाम",
    free_tier: "फ्री टियर",
    included_features: "शामिल सुविधाएँ",
    no_active_subscription: "कोई सक्रिय सदस्यता नहीं मिली।",
    loading: "लोड हो रहा है...",
    configure_gst: "जीएसटी कॉन्फ़िगर करें",
    processing: "प्रक्रिया में है...",
    upgrade_plan: "योजना अपग्रेड करें",
    error_fetch_subscription: "सदस्यता विवरण लाने में विफल।",
    error_generic_subscription: "सदस्यता विवरण लाते समय एक त्रुटि हुई।",
    error_select_plan: "कृपया अपग्रेड करने के लिए एक योजना चुनें।",
    success_upgrade: "सदस्यता सफलतापूर्वक अपग्रेड की गई!",
    error_upgrade: "सदस्यता अपग्रेड करने में विफल।",
    error_upgrade_generic: "सदस्यता अपग्रेड करते समय एक त्रुटि हुई।",
    error_business_not_found: "व्यापार प्रोफ़ाइल नहीं मिली। कृपया पहले एक बनाएँ।",
    error_fetch_business: "व्यापार विवरण लाने में विफल।"
  },
  purchases_page: {
    purchases: "खरीदारी",
    manage_purchases: "अपनी खरीदारी और भुगतान प्रबंधित करें",
    add_purchase: "खरीद जोड़ें",
    total_purchases: "कुल खरीदारी",
    total_spent: "कुल खर्च",
    pending_purchases: "लंबित खरीदारी",
    pending_payment: "लंबित भुगतान",
    search_placeholder: "आपूर्तिकर्ता नाम या खरीद आईडी द्वारा खोजें...",
    all: "सभी",
    pending: "लंबित",
    unpaid: "अवैतनिक",
    no_purchases: "कोई खरीदारी नहीं",
    no_purchases_desc: "कोई खरीदारी नहीं मिली",
    id_date: "आईडी / दिनांक",
    supplier: "आपूर्तिकर्ता",
    amount: "राशि",
    before_tax: "कर से पहले",
    status: "स्थिति",
    payment_status: "भुगतान स्थिति",
    actions: "क्रियाएं",
    delete_confirmation: "क्या आप इस खरीद को हटाना चाहते हैं?",
    paid: "भुगतान किया",
    partial: "आंशिक"
  },
  suppliers_page: {
    suppliers: "आपूर्तिकर्ता",
    manage_suppliers: "अपने आपूर्तिकर्ताओं और खरीदारी का प्रबंधन करें",
    add_new_supplier: "नया आपूर्तिकर्ता जोड़ें",
    total_suppliers: "कुल आपूर्तिकर्ता",
    total_purchases: "कुल खरीदारी",
    active_suppliers: "सक्रिय आपूर्तिकर्ता",
    success_rate: "सफलता दर",
    search_suppliers: "नाम या संपर्क व्यक्ति द्वारा खोजें...",
    no_suppliers: "कोई आपूर्तिकर्ता नहीं",
    edit_supplier: "आपूर्तिकर्ता संपादित करें",
    delete_supplier: "आपूर्तिकर्ता हटाएं",
    supplier_name: "आपूर्तिकर्ता का नाम",
    contact_person: "संपर्क व्यक्ति",
    phone: "फ़ोन",
    email: "ईमेल",
    gstin: "जीएसटीआईएन",
    address: "पता",
    cancel: "रद्द करें",
    save: "सहेजें",
    delete_confirmation: "क्या आप वाकई इस आपूर्तिकर्ता को हटाना चाहते हैं?",
    actions: "क्रियाएं",
    add_supplier: "आपूर्तिकर्ता जोड़ें",
    update_supplier: "आपूर्तिकर्ता अपडेट करें",
    supplier_details: "आपूर्तिकर्ता विवरण",
    status: "स्थिति",
    general_liaison: "सामान्य संपर्क",
    terms_net: "शर्तें: नेट",
    no_suppliers_desc: "कोई आपूर्तिकर्ता नहीं मिला"
  },
  gst_page: {
    tax_gst: "कर और जीएसटी",
    manage_gst: "अपने जीएसटी रिटर्न और कर अनुपालन का प्रबंधन करें",
    export_report: "टैक्स रिपोर्ट निर्यात करें",
    input_tax_credit: "इनपुट टैक्स क्रेडिट",
    tax_liability: "कर देयता",
    pending_returns: "लंबित रिटर्न",
    compliance_score: "अनुपालन स्कोर",
    gstin_check: "जीएसटीआईएन चेक",
    gst_returns: "जीएसटी रिटर्न",
    auto_file_gst: "ऑटो फाइल जीएसटी",
    past_returns: "पिछले रिटर्न",
    gstin_verification: "जीएसटीआईएन सत्यापन",
    verify_gst_desc: "सरकारी डेटाबेस के साथ जीएसटी नंबर सत्यापित करें।",
    verify_gst_subdesc: "तत्काल परिणामों के साथ किसी भी 15-अंकीय जीएसटी नंबर को जल्दी से सत्यापित करें।",
    enter_gst_number: "15-अंकीय जीएसटी नंबर दर्ज करें...",
    check_gst_number: "जीएसटी नंबर चेक करें",
    checking: "जाँच हो रही है...",
    gst_verified: "जीएसटी नंबर सत्यापित",
    verified_successfully: "सफलतापूर्वक सत्यापित",
    business_name: "व्यापार का नाम",
    state: "राज्य",
    invalid_gst_number: "अमान्य जीएसटी नंबर",
    gst_not_valid: "जीएसटी नंबर मान्य नहीं है",
    all_returns_filed: "सभी रिटर्न दाखिल",
    returns_up_to_date: "आपके जीएसटी रिटर्न अपडेट हैं",
    gstr1_sales: "GSTR-1 (बिक्री)",
    feature_auto_pop: "फ़ीचर: चालान से ऑटो-जनसंख्या",
    coming_soon: "जल्द आ रहा है",
    gstr3b_summary: "GSTR-3B (सारांश)",
    feature_liability: "फ़ीचर: वन-क्लिक देयता ऑफसेट",
    history_coming_soon: "इतिहास सुविधा जल्द आ रही है।",
    return_type: "रिटर्न प्रकार",
    period: "अवधि",
    due_date: "देय तिथि",
    status: "स्थिति",
    actions: "क्रियाएं",
    submit_return: "रिटर्न सबमिट करें"
  },
  customers_page: {
    customers: "ग्राहक",
    manage_customers: "अपने ग्राहकों और भुगतानों का प्रबंधन करें",
    add_new_customer: "नया ग्राहक जोड़ें",
    total_customers: "कुल ग्राहक",
    paid_customers: "भुगतान किए गए ग्राहक",
    pending_payments: "लंबित भुगतान",
    total_due: "कुल देय",
    search_placeholder: "नाम, ईमेल या फोन द्वारा खोजें...",
    all: "सभी",
    paid: "भुगतान किया",
    due: "देय",
    no_customers: "कोई ग्राहक नहीं",
    no_customers_desc: "कोई ग्राहक नहीं मिला",
    customer_name: "ग्राहक का नाम",
    id: "आईडी",
    contact_details: "संपर्क विवरण",
    current_status: "वर्तमान स्थिति",
    pending_payment: "लंबित भुगतान",
    amount_due: "देय राशि",
    actions: "क्रियाएं",
    delete_confirmation: "क्या आप इस ग्राहक को हटाना चाहते हैं?",
    status_pending: "लंबित भुगतान",
    status_no_dues: "कोई बकाया नहीं",
    last_active: "अंतिम सक्रिय"
  },
  inventory_page: {
    inventory: "इन्वेंटरी",
    manage_inventory: "अपने उत्पादों और स्टॉक स्तरों का प्रबंधन करें",
    add_product: "उत्पाद जोड़ें",
    total_items: "कुल आइटम",
    low_stock: "कम स्टॉक",
    out_of_stock: "आउट ऑफ स्टॉक",
    stock_value: "स्टॉक मूल्य",
    search_placeholder: "कोड, नाम या प्रकार द्वारा उत्पाद खोजें...",
    all_items: "सभी आइटम",
    product_name: "उत्पाद का नाम",
    product_code: "उत्पाद कोड",
    stock_status: "स्टॉक स्थिति",
    price: "कीमत",
    before_tax: "कर से पहले",
    actions: "क्रियाएं",
    in_stock: "स्टॉक में",
    units: "इकाइयाँ",
    delete_confirmation: "क्या आप इस उत्पाद को हटाना चाहते हैं?",
    no_products: "कोई उत्पाद नहीं",
    no_products_desc: "कोई उत्पाद नहीं मिला",
    edit_product: "उत्पाद संपादित करें",
    delete_product: "उत्पाद हटाएं",
    loading_sample_data: "लोड हो रहा है... नमूना डेटा दिखा रहा है"
  },
  business_settings_page: {
    business_settings: "व्यापार सेटिंग्स",
    manage_business_preferences: "अपनी व्यावसायिक प्राथमिकताओं और कॉन्फ़िगरेशन को प्रबंधित करें",
    general_settings: "सामान्य सेटिंग्स",
    configure_general_settings: "बुनियादी व्यापार सेटिंग्स को कॉन्फ़िगर करें",
    language: "भाषा",
    currency: "मुद्रा",
    select_currency: "मुद्रा चुनें",
    timezone: "समय क्षेत्र",
    select_timezone: "समय क्षेत्र चुनें",
    notifications: "सूचनाएं",
    manage_notification_preferences: "अपनी अधिसूचना प्राथमिकताओं को प्रबंधित करें",
    low_stock_alerts: "कम स्टॉक अलर्ट",
    low_stock_description: "इन्वेंट्री कम होने पर सूचित करें",
    expiring_items: "समाप्त होने वाली वस्तुएं",
    expiring_items_description: "समाप्त होने वाली वस्तुओं के बारे में सूचित करें",
    order_updates: "ऑर्डर अपडेट",
    order_updates_description: "नए ऑर्डर और स्थिति परिवर्तनों के बारे में सूचित करें",
    saving: "सहेज रहा है...",
    save_changes: "परिवर्तनों को सहेजें",
    failed_to_load_settings: "सेटिंग्स लोड करने में विफल",
    settings_saved_successfully: "सेटिंग्स सफलतापूर्वक सहेजी गईं",
    failed_to_save_settings: "सेटिंग्स सहेजने में विफल"
  },
  billing_page: {
    title: "वित्तीय और बिलिंग",
    subtitle: "कॉर्पोरेट सदस्यता और संसाधन निपटान के लिए वास्तुकला",
    tabs: {
      subscription: "सदस्यता",
      history: "इतिहास",
      settlements: "निपटान",
      corporate_profile: "कॉर्पोरेट प्रोफ़ाइल"
    },
    subscription: {
      tier_status: "टियर स्थिति",
      authenticated: "प्रमाणित",
      renewal: "नवीनीकरण: ",
      ascend_plan: "योजना अपग्रेड करें",
      equilibrium_method: "संतुलन विधि",
      recent_settlement: "हालिया निपटान",
      verified: "सत्यापित"
    },
    history: {
      invoice_identifier: "चालान पहचानकर्ता",
      issuance_date: "जारी करने की तिथि",
      settlement_amount: "निपटान राशि",
      status: "स्थिति",
      actions: "क्रियाएं",
      no_history_title: "कोई निपटान इतिहास नहीं",
      no_history_desc: "आपके सत्यापित चालान प्रमाणीकरण के बाद यहां दिखाई देंगे।"
    },
    settlements: {
      architecture_title: "निपटान वास्तुकला",
      architecture_desc: "अधिकृत कॉर्पोरेट पहुंच बिंदु",
      initialize_method: "विधि प्रारंभ करें",
      no_vectors: "कोई निपटान वैक्टर पहचाना नहीं गया"
    },
    profile: {
      corporate_identity: "कॉर्पोरेट पहचान",
      tax_protocol: "कर प्रोटोकॉल / GSTIN",
      registered_address: "पंजीकृत पता",
      metropolis: "महानगर",
      jurisdiction: "अधिकार क्षेत्र",
      postal_code: "डाक कोड",
      sovereignty: "संप्रभुता",
      synchronizing: "सिंक्रनाइज़ हो रहा है...",
      authorize_updates: "अपडेट अधिकृत करें",
      update_success: "बिलिंग जानकारी सफलतापूर्वक अपडेट की गई"
    }
  },
  locations_page: {
    title: "स्थान",
    subtitle: "कई स्थानों और स्टॉक ट्रांसफर का प्रबंधन करें",
    transfer_stock: "स्टॉक ट्रांसफर",
    add_location: "स्थान जोड़ें",
    total_locations: "स्थान",
    active_locations: "सक्रिय स्थान",
    total_stock: "कुल स्टॉक",
    transfers_progress: "प्रगति में स्थानान्तरण",
    tabs: {
      locations: "स्थान",
      all_stock: "सभी स्थानों का स्टॉक",
      transfers: "स्टॉक स्थानान्तरण",
      analytics: "एनालिटिक्स"
    },
    table: {
      location_name: "स्थान का नाम",
      type: "प्रकार",
      address: "पता",
      contact: "संपर्क",
      status: "स्थिति",
      actions: "क्रियाएं",
      active: "सक्रिय",
      inactive: "निष्क्रिय",
      store: "स्टोर",
      warehouse: "गोदाम",
      view_details: "विवरण देखें",
      edit: "संपादित करें",
      delete: "हटाएं"
    },
    transfer_table: {
      date: "स्थानांतरण तिथि",
      date_label: "तिथि",
      route: "से → तक"
    },
    empty_state: {
      no_locations: "कोई स्थान नहीं मिला",
      no_locations_desc: "आपने अभी तक कोई स्थान नहीं जोड़ा है। शुरू करने के लिए एक स्टोर या गोदाम जोड़ें।",
      no_transfers: "कोई स्थानान्तरण नहीं मिला",
      no_transfers_desc: "आपने अभी तक कोई स्टॉक स्थानान्तरण शुरू नहीं किया है।",
      no_stock: "कोई स्टॉक डेटा नहीं",
      no_stock_desc: "चयनित स्थान के लिए कोई स्टॉक डेटा उपलब्ध नहीं है।"
    },
    analytics: {
      sales_analysis: "बिक्री विश्लेषण",
      coming_soon: "उन्नत विश्लेषण जल्द ही आ रहा है।"
    }
  },
  usage_page: {
    title: "उपयोग और सीमाएं",
    subtitle: "अपना उपयोग और सीमाएं देखें",
    export_report: "रिपोर्ट निर्यात करें",
    cards: {
      api_calls: "API कॉल",
      storage_used: "भंडारण उपयोग",
      data_transfer: "डेटा स्थानांतरण",
      processing_time: "प्रसंस्करण समय"
    },
    tabs: {
      system_status: "सिस्टम स्थिति",
      usage_limits: "उपयोग सीमाएं",
      usage_history: "उपयोग इतिहास",
      alerts: "अलर्ट"
    },
    monitor: {
      system_health: "सिस्टम स्वास्थ्य",
      current_system_status: "वर्तमान सिस्टम स्थिति",
      uptime: "अपटाइम",
      response_time: "प्रतिक्रिया समय",
      errors: "त्रुटियां",
      database_usage: "डेटाबेस उपयोग",
      auto_scaling: "ऑटो स्केलिंग",
      system_running_smoothly: "सिस्टम सुचारू रूप से चल रहा है।",
      system_running_desc: "सिस्टम उपयोग के आधार पर संसाधनों का स्वचालित रूप से प्रबंधन कर रहा है। तेज प्रदर्शन के लिए सिस्टम अच्छा चल रहा है।",
      manage_auto_scaling: "ऑटो स्केलिंग प्रबंधित करें"
    },
    quotas: {
      usage_limit: "उपयोग सीमा",
      used: "उपयोग किया गया",
      total_limit: "कुल सीमा"
    },
    history: {
      date: "तारीख",
      api_calls: "API कॉल",
      storage: "भंडारण",
      data_transfer: "डेटा स्थानांतरण",
      reqs: "अनुरोध",
      no_history: "कोई इतिहास नहीं",
      no_history_desc: "उपयोग इतिहास यहां दिखाई देगा"
    },
    alerts: {
      fix_issue: "समस्या ठीक करें",
      all_systems_good: "सभी सिस्टम ठीक हैं",
      no_issues_found: "कोई समस्या नहीं मिली"
    }
  },
  sidebar: {
    menu: {
      overview: "अवलोकन",
      business: "व्यापार",
      finance: "वित्त",
      system: "सिस्टम"
    },
    items: {
      dashboard: "डैशबोर्ड",
      analytics: "एनालिटिक्स",
      business_profile: "व्यापार प्रोफ़ाइल",
      inventory: "इन्वेंटरी",
      orders: "ऑर्डर",
      purchases: "खरीद",
      customers: "ग्राहक",
      suppliers: "आपूर्तिकर्ता",
      business_settings: "व्यापार सेटिंग्स",
      tax_gst: "टैक्स और GST",
      billing: "बिलिंग",
      subscription: "सदस्यता",
      locations: "स्थान",
      settings: "सेटिंग्स",
      usage: "उपयोग"
    },
    footer: {
      upgrade_pro: "Pro में अपग्रेड करें",
      account: "खाता",
      billing: "बिलिंग",
      notifications: "सूचनाएं",
      logout: "लॉग आउट"
    }
  }
};